import { GraphQLClient, RequestOptions } from "graphql-request"
import gql from "graphql-tag"

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: string | Date; output: string; }
  DateTime: { input: string | Date; output: string; }
  Decimal: { input: string | number; output: string; }
  JSONString: { input: string; output: string; }
  StringOrList: { input: string | string[]; output: string | string[]; }
  UUID: { input: string; output: string; }
};

/** Type for the ARVComp Model */
export type ArvCompType = {
  __typename?: 'ARVCompType';
  /** ARV comps chosen for this analysis. */
  analysisSet: Array<AnalysisType>;
  analysiscompsSet: Array<AnalysisCompType>;
  area?: Maybe<Scalars['Int']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  city: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  dateSold?: Maybe<Scalars['Date']['output']>;
  daysOnMarket?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  estimatedValue?: Maybe<Scalars['Int']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  /** Single image to use for display */
  heroImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isSelected: Scalars['Boolean']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  lotSize?: Maybe<Scalars['Float']['output']>;
  media?: Maybe<Array<Scalars['String']['output']>>;
  /** Price per square foot */
  pricePerSqft?: Maybe<Scalars['Float']['output']>;
  pricing?: Maybe<Scalars['JSONString']['output']>;
  propertyType?: Maybe<AnalyzerArvCompPropertyTypeChoices>;
  /** Last sold price */
  soldPrice?: Maybe<Scalars['Int']['output']>;
  state: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  stories?: Maybe<Scalars['Int']['output']>;
  street: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  yearBuilt?: Maybe<Scalars['Int']['output']>;
  zipcode: Scalars['String']['output'];
};

export type AccountExistsType = {
  __typename?: 'AccountExistsType';
  /** True if an account for the given email exists. */
  exists: Scalars['Boolean']['output'];
};

/** An enumeration. */
export type AccountsUserAttributionChoices =
  /** Attended a Backflip Hosted Event */
  | 'ATTENDED_A_BACKFLIP_HOSTED_EVENT'
  /** A Friend or Partner Referred Me */
  | 'A_FRIEND_OR_PARTNER_REFERRED_ME'
  /** I heard about Backflip on a podcast */
  | 'I_HEARD_ABOUT_BACKFLIP_ON_A_PODCAST'
  /** Met the Backflip Team at an Event */
  | 'MET_THE_BACKFLIP_TEAM_AT_AN_EVENT'
  /** Other or I can't remember */
  | 'OTHER_OR_I_CAN_T_REMEMBER'
  /** Other or I can't remember */
  | 'OTHER_OR_I_CAN_T_REMEMBER_13'
  /** Read about Backflip in Press */
  | 'READ_ABOUT_BACKFLIP_IN_PRESS'
  /** Read about Backflip in the press */
  | 'READ_ABOUT_BACKFLIP_IN_THE_PRESS'
  /** Received a piece of Backflip mail */
  | 'RECEIVED_A_PIECE_OF_BACKFLIP_MAIL'
  /** Received a piece of Backflip Mail */
  | 'RECEIVED_A_PIECE_OF_BACKFLIP_MAIL_12'
  /** Saw an online ad */
  | 'SAW_AN_ONLINE_AD'
  /** Saw a Backflip Ad */
  | 'SAW_A_BACKFLIP_AD'
  /** Saw Backflip at an event */
  | 'SAW_BACKFLIP_AT_AN_EVENT'
  /** Saw Backflip on Social Media */
  | 'SAW_BACKFLIP_ON_SOCIAL_MEDIA'
  /** Someone personally referred me */
  | 'SOMEONE_PERSONALLY_REFERRED_ME';

/** An enumeration. */
export type AccountsUserTimeCommitmentChoices =
  /** Casual */
  | 'CASUAL'
  /** Full-time */
  | 'FULL_TIME'
  /** Part-time */
  | 'PART_TIME';

/** Adjustment Breakdown */
export type AdjustmentBreakdown = {
  __typename?: 'AdjustmentBreakdown';
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

/** Inputted Query Preference Data to Update an Analysis */
export type AnalysisCompInput = {
  areaMax?: InputMaybe<Scalars['Int']['input']>;
  areaMin?: InputMaybe<Scalars['Int']['input']>;
  bathsMax?: InputMaybe<Scalars['Float']['input']>;
  bathsMin?: InputMaybe<Scalars['Float']['input']>;
  bedsMax?: InputMaybe<Scalars['Int']['input']>;
  bedsMin?: InputMaybe<Scalars['Int']['input']>;
  daysSinceSold?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  listingStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Type for the AnalysisComp Model */
export type AnalysisCompType = {
  __typename?: 'AnalysisCompType';
  arvcomp?: Maybe<ArvCompType>;
  /** Determine whether the Comp was Manually Added or Not */
  compType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSelected: Scalars['Boolean']['output'];
  originalIndex?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Analysis data provided for update */
export type AnalysisFeedbackInput = {
  feedbackScore?: InputMaybe<Scalars['Int']['input']>;
  feedbackText?: InputMaybe<Scalars['String']['input']>;
};

/** Analysis Feedback Type */
export type AnalysisFeedbackType = {
  __typename?: 'AnalysisFeedbackType';
  /** Analysis receiving Feedback */
  analysis: AnalysisType;
  component?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  score?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Analysis data provided for update */
export type AnalysisInput = {
  afterRepairValue?: InputMaybe<Scalars['Int']['input']>;
  area?: InputMaybe<Scalars['Int']['input']>;
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  cashToClose?: InputMaybe<Scalars['Float']['input']>;
  debtFinancing?: InputMaybe<Scalars['Int']['input']>;
  distance?: InputMaybe<Scalars['Float']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  financingCost?: InputMaybe<Scalars['Float']['input']>;
  financingFees?: InputMaybe<Scalars['Float']['input']>;
  grossProfitPotential?: InputMaybe<Scalars['Int']['input']>;
  holdPeriod?: InputMaybe<Scalars['Int']['input']>;
  interestExpenseLt?: InputMaybe<Scalars['Float']['input']>;
  interestExpenseSt?: InputMaybe<Scalars['Float']['input']>;
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  loanTerm?: InputMaybe<Scalars['Int']['input']>;
  loanToCostAtCompletion?: InputMaybe<Scalars['Float']['input']>;
  monthlyCashFlow?: InputMaybe<Scalars['Int']['input']>;
  monthlyHoldingCosts?: InputMaybe<Scalars['Float']['input']>;
  monthlyPayment?: InputMaybe<Scalars['Float']['input']>;
  oneTimeCosts?: InputMaybe<Scalars['Float']['input']>;
  opex?: InputMaybe<Scalars['Int']['input']>;
  profitPotential?: InputMaybe<Scalars['Float']['input']>;
  purchaseCost?: InputMaybe<Scalars['Float']['input']>;
  purchasePrice?: InputMaybe<Scalars['Int']['input']>;
  rehabCost?: InputMaybe<Scalars['Int']['input']>;
  rehabCostPerSquareFoot?: InputMaybe<Scalars['Float']['input']>;
  rent?: InputMaybe<Scalars['Int']['input']>;
  rewardsCredit?: InputMaybe<Scalars['Float']['input']>;
  roiDealScore?: InputMaybe<Scalars['String']['input']>;
  saleCost?: InputMaybe<Scalars['Float']['input']>;
  selectedCompIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  totalCostBasis?: InputMaybe<Scalars['Float']['input']>;
  totalLoanAmount?: InputMaybe<Scalars['Float']['input']>;
};

/** AnalysisStats */
export type AnalysisStatsType = {
  __typename?: 'AnalysisStatsType';
  /** Number of analysis' created with Analyzer */
  manualCount?: Maybe<Scalars['Int']['output']>;
  /** Number of analysis' sourced with My Leads */
  sourcedCount?: Maybe<Scalars['Int']['output']>;
  /** Top 10% average manual analysis count */
  topAverageManualCount?: Maybe<Scalars['Int']['output']>;
  /** Total number of analysis' created */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** Number of analysis' not seen by user */
  unreadCount?: Maybe<Scalars['Int']['output']>;
  /** Number of analysis' with high ROI not seen by user */
  unreadHighRoiCount?: Maybe<Scalars['Int']['output']>;
};

/** Type for the Analysis Model */
export type AnalysisType = {
  __typename?: 'AnalysisType';
  afterRepairValue?: Maybe<Scalars['Int']['output']>;
  analysisSet: Array<AnalysisType>;
  analysisType?: Maybe<Scalars['String']['output']>;
  analysiscompsSet: Array<AnalysisCompType>;
  area?: Maybe<Scalars['Int']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  /** The amount needed at closing */
  cashToClose?: Maybe<Scalars['Float']['output']>;
  compProvider?: Maybe<Scalars['String']['output']>;
  /** The comp query preferences for filtering */
  compQueryPreference?: Maybe<CompQueryPreferenceType>;
  /** Comp Query Preference by Analysis */
  compquerypreferenceSet: Array<CompQueryPreferenceType>;
  /** All comps for the analysis */
  comps?: Maybe<Array<Maybe<AnalysisCompType>>>;
  createdAt: Scalars['DateTime']['output'];
  debtFinancing: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  duration: Scalars['Int']['output'];
  estimatedAnnualReturn?: Maybe<Scalars['Float']['output']>;
  estimatedRent?: Maybe<Scalars['Int']['output']>;
  favoritedAt?: Maybe<Scalars['DateTime']['output']>;
  financingCost: Scalars['Float']['output'];
  /** The fees associated with originating the loan */
  financingFees?: Maybe<Scalars['Float']['output']>;
  /** The difference between ARV and cost basis */
  grossProfitPotential?: Maybe<Scalars['Float']['output']>;
  /** Duration of the loan */
  holdPeriod?: Maybe<Scalars['Int']['output']>;
  /** The monthly cost of loan */
  holdingCosts?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  interestExpenseLt: Scalars['Float']['output'];
  interestExpenseSt: Scalars['Float']['output'];
  /** The interest rate for the loan */
  interestRate?: Maybe<Scalars['Float']['output']>;
  isBetaCohort?: Maybe<Scalars['Boolean']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  /** Indicates if the analysis is favorited */
  isFavorite?: Maybe<Scalars['Boolean']['output']>;
  isFirstManualAnalysis?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the analysis is eligible for notifications */
  isNotificationsEligible?: Maybe<Scalars['Boolean']['output']>;
  isSourced: Scalars['Boolean']['output'];
  /** The latest manually added comp */
  latestManualComp?: Maybe<AnalysisCompType>;
  loanTerm?: Maybe<Scalars['Int']['output']>;
  /** Leverage */
  loanToCostAtCompletion?: Maybe<Scalars['Float']['output']>;
  /** The associated analysis. */
  loanapplicationSet: Array<LoanApplicationType>;
  lotSize?: Maybe<Scalars['Float']['output']>;
  medianHomeSalePrice?: Maybe<Scalars['Int']['output']>;
  monthlyCashFlow?: Maybe<Scalars['Int']['output']>;
  monthlyHoldingCosts?: Maybe<Scalars['Float']['output']>;
  /** The monthly payment for the loan */
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** User notes on the analysis */
  notes?: Maybe<Scalars['String']['output']>;
  /** Indicates if the analysis has notifications enabled */
  notificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationsEnabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** One time fees associated with the transaction */
  oneTimeCosts?: Maybe<Scalars['Float']['output']>;
  opex?: Maybe<Scalars['Int']['output']>;
  overrideAttributes?: Maybe<Scalars['JSONString']['output']>;
  /** Indicates the source of the purchase price */
  priceSelection?: Maybe<Scalars['String']['output']>;
  profit?: Maybe<Scalars['Int']['output']>;
  profitPotential?: Maybe<Scalars['Float']['output']>;
  property: PropertyType;
  /** Property Status at time of Analysis */
  propertyStatus?: Maybe<Scalars['String']['output']>;
  purchaseCost: Scalars['Float']['output'];
  purchasePrice?: Maybe<Scalars['Int']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  rehabCost?: Maybe<Scalars['Int']['output']>;
  rehabCostPerSquareFoot?: Maybe<Scalars['Float']['output']>;
  rent?: Maybe<Scalars['Int']['output']>;
  returnOnInvestment?: Maybe<Scalars['Float']['output']>;
  rewardsCredit?: Maybe<Scalars['Float']['output']>;
  roiDealScore?: Maybe<Scalars['String']['output']>;
  saleCost: Scalars['Float']['output'];
  sharedFrom?: Maybe<AnalysisType>;
  sourcedProperty?: Maybe<SourcedPropertyType>;
  strategy: Scalars['String']['output'];
  /** A list of tags */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The sum of the purchase price and rehab cost */
  totalCostBasis?: Maybe<Scalars['Float']['output']>;
  /** The total loan amount */
  totalLoanAmount?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** User that created the property analysis. */
  user: UserType;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
};

/** An enumeration. */
export type AnalyzerArvCompPropertyTypeChoices =
  /** Condo */
  | 'CONDO'
  /** Multifamily */
  | 'MULTIFAMILY'
  /** Single Family */
  | 'SINGLE_FAMILY'
  /** Townhouse */
  | 'TOWNHOUSE';

export type AppleLoginMutation = {
  __typename?: 'AppleLoginMutation';
  token?: Maybe<Scalars['String']['output']>;
};

export type BfLoanApplicationType = LoanType & Node & {
  __typename?: 'BFLoanApplicationType';
  afterRepairValue?: Maybe<Scalars['Int']['output']>;
  /** The associated analysis. */
  analysis?: Maybe<AnalysisType>;
  borrower?: Maybe<Scalars['String']['output']>;
  borrowerNames?: Maybe<Array<Scalars['String']['output']>>;
  cashAvailable?: Maybe<Scalars['String']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  /** The sum of the purchase price and the rehab estimate */
  costBasis?: Maybe<Scalars['Float']['output']>;
  creditScore?: Maybe<Scalars['String']['output']>;
  estimatedCashToBorrower?: Maybe<Scalars['Float']['output']>;
  /** The cash to close minus any closing credits */
  estimatedCashToClose?: Maybe<Scalars['Float']['output']>;
  /** Sum of all fees associated with loan */
  financingFee?: Maybe<Scalars['Float']['output']>;
  flipsCompleted?: Maybe<Scalars['Int']['output']>;
  /** The difference between ARV and cost basis */
  grossProfit?: Maybe<Scalars['Float']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  interestRate?: Maybe<Scalars['Float']['output']>;
  loanProduct: LoanProduct;
  loanToCost?: Maybe<Scalars['Float']['output']>;
  /** All milestones for a loan application with their current status. */
  milestones: Array<MilestoneType>;
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  originationRate?: Maybe<Scalars['Float']['output']>;
  /** Post-close information for a loan application. */
  postClose?: Maybe<PostCloseType>;
  /** The real estate property. */
  property: PropertyType;
  purchasePrice: Scalars['Int']['output'];
  rentalProperties?: Maybe<Scalars['Int']['output']>;
  status: LoanStatus;
  statusLabel: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  targetCloseDate?: Maybe<Scalars['Date']['output']>;
  /** All tasks for the loan application with metadata. Returned in a possible display order. */
  tasks: Array<LoanTaskType>;
  /** All current stages of the application process with metadata. Returned in timeline order. */
  timeline: Array<TimelineItemType>;
  /** The current stage of the application process. */
  timelineStage: TimelineStageType;
  totalLoanAmount?: Maybe<Scalars['Float']['output']>;
  /** Link to the document upload portal. (via hubspot) */
  uploadPortalLink?: Maybe<Scalars['String']['output']>;
};

export type BfLoanApplicationTypeConnection = {
  __typename?: 'BFLoanApplicationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<BfLoanApplicationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `BFLoanApplicationType` and its cursor. */
export type BfLoanApplicationTypeEdge = {
  __typename?: 'BFLoanApplicationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<BfLoanApplicationType>;
};

/** Badges */
export type BadgesType = {
  __typename?: 'BadgesType';
  /** The number of new analyses user has not read */
  unreadAnalysisCount?: Maybe<Scalars['Int']['output']>;
  /** The number of new buybox analyses user has not read */
  unreadBuyBoxCount?: Maybe<Scalars['Int']['output']>;
};

export type BudgetContactDetailsType = {
  __typename?: 'BudgetContactDetailsType';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type BudgetLineItemType = {
  __typename?: 'BudgetLineItemType';
  budget?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  memo?: Maybe<Scalars['String']['output']>;
  selection?: Maybe<Scalars['StringOrList']['output']>;
};

export type BudgetPropertyDetailsType = {
  __typename?: 'BudgetPropertyDetailsType';
  id: Scalars['UUID']['output'];
  propertyBaths?: Maybe<Scalars['Decimal']['output']>;
  propertyBeds?: Maybe<Scalars['Int']['output']>;
  propertySqFt?: Maybe<Scalars['Int']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type BuyBoxMutation = {
  __typename?: 'BuyBoxMutation';
  buyBox?: Maybe<BuyBoxType>;
};

/** BuyBoxType */
export type BuyBoxType = {
  __typename?: 'BuyBoxType';
  areaMax?: Maybe<Scalars['Int']['output']>;
  areaMin?: Maybe<Scalars['Int']['output']>;
  arvMax?: Maybe<Scalars['Int']['output']>;
  arvMin?: Maybe<Scalars['Int']['output']>;
  baths?: Maybe<Array<Scalars['String']['output']>>;
  beds?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['UUID']['output'];
  priceMax?: Maybe<Scalars['Int']['output']>;
  priceMin?: Maybe<Scalars['Int']['output']>;
  profitMin?: Maybe<Scalars['Int']['output']>;
  yearBuiltMax?: Maybe<Scalars['Int']['output']>;
  yearBuiltMin?: Maybe<Scalars['Int']['output']>;
  zipCodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type ChangePasswordMutation = {
  __typename?: 'ChangePasswordMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type ClosesToRewardsPointsType = {
  __typename?: 'ClosesToRewardsPointsType';
  nextCloseReward?: Maybe<Scalars['Int']['output']>;
  nthClose?: Maybe<Scalars['Int']['output']>;
  nthCloseLabel?: Maybe<Scalars['String']['output']>;
};

/** GraphQL type for CommunityEvent */
export type CommunityEventType = {
  __typename?: 'CommunityEventType';
  /** The physical address where the event will be held. */
  address?: Maybe<Scalars['String']['output']>;
  /** A detailed description of the event, including what attendees can expect. */
  description: Scalars['String']['output'];
  /** Whether this is an in-person or virtual event. */
  eventType: DynamicContentCommunityEventEventTypeChoices;
  eventUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  /** The image that will show up in the app associated with this event. */
  image?: Maybe<Scalars['String']['output']>;
  market?: Maybe<EventMarketType>;
  /** The title or name of the community event. */
  name: Scalars['String']['output'];
  /** The date and time when the event begins. */
  startTime: Scalars['DateTime']['output'];
  venueName?: Maybe<Scalars['String']['output']>;
};

/** Type for the CompQueryPreference Model */
export type CompQueryPreferenceType = {
  __typename?: 'CompQueryPreferenceType';
  /** Comp Query Preference by Analysis */
  analysis: AnalysisType;
  areaMax?: Maybe<Scalars['Int']['output']>;
  areaMin?: Maybe<Scalars['Int']['output']>;
  bathsMax?: Maybe<Scalars['Float']['output']>;
  bathsMin?: Maybe<Scalars['Float']['output']>;
  bedsMax?: Maybe<Scalars['Int']['output']>;
  bedsMin?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  daysSinceSold?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  listingStatuses?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CreateAnalysisCompMutation = {
  __typename?: 'CreateAnalysisCompMutation';
  analysis?: Maybe<AnalysisType>;
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Create/Update Analysis Feedback */
export type CreateAnalysisFeedbackMutation = {
  __typename?: 'CreateAnalysisFeedbackMutation';
  analysisFeedback?: Maybe<AnalysisFeedbackType>;
};

/** Create a new analysis */
export type CreateAnalysisMutation = {
  __typename?: 'CreateAnalysisMutation';
  analysis?: Maybe<AnalysisType>;
};

/** Create a new loan application */
export type CreateLoanApplicationMutation = {
  __typename?: 'CreateLoanApplicationMutation';
  loanApplication?: Maybe<LoanApplicationType>;
};

export type CreatePreApprovalRequestMutation = {
  __typename?: 'CreatePreApprovalRequestMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  preApprovalRequest?: Maybe<PreApprovalRequestType>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Share an Existing Analysis */
export type CreateShareableAnalysisMutation = {
  __typename?: 'CreateShareableAnalysisMutation';
  analysis?: Maybe<AnalysisType>;
};

/** Created Credit Report Result */
export type CreatedCreditReportResult = {
  __typename?: 'CreatedCreditReportResult';
  error?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Create a Credit Report Mutation to Retrieve Credit Report Data, Save it, and Send it to HubSpot */
export type CreditReportMutation = {
  __typename?: 'CreditReportMutation';
  result?: Maybe<CreatedCreditReportResult>;
};

export type DeleteAccountMutation = {
  __typename?: 'DeleteAccountMutation';
  result?: Maybe<DeleteAccountResult>;
};

export type DeleteAccountResult = {
  __typename?: 'DeleteAccountResult';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAnalysisMutation = {
  __typename?: 'DeleteAnalysisMutation';
  deleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteLoanApplicationMutation = {
  __typename?: 'DeleteLoanApplicationMutation';
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** The id of the loan applicaiton to redirect to post-deletion if needed. */
  redirectLoanId?: Maybe<Scalars['ID']['output']>;
};

export type DisconnectMyLeadsInput = {
  explanation?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type DisconnectMyLeadsMutation = {
  __typename?: 'DisconnectMyLeadsMutation';
  result?: Maybe<Scalars['Boolean']['output']>;
};

export type DrawType = {
  __typename?: 'DrawType';
  /** Draw amount */
  amount?: Maybe<Scalars['Float']['output']>;
  /** Date the draw was funded */
  fundedDate?: Maybe<Scalars['DateTime']['output']>;
  /** Draw ID */
  id?: Maybe<Scalars['ID']['output']>;
  /** Draw number */
  number?: Maybe<Scalars['String']['output']>;
  /** Draw status */
  status?: Maybe<Scalars['String']['output']>;
};

export type DrawsBudgetType = {
  __typename?: 'DrawsBudgetType';
  /** Remaining budget amount */
  budgetedLeft?: Maybe<Scalars['Float']['output']>;
  /** Total budgeted amount */
  budgetedTotal?: Maybe<Scalars['Float']['output']>;
  /** Total amount of completed draws */
  completedDrawsTotal?: Maybe<Scalars['Float']['output']>;
  /** List of draws for this loan */
  draws?: Maybe<Array<DrawType>>;
  /** Total amount of pending draws */
  pendingDrawsTotal?: Maybe<Scalars['Float']['output']>;
  /** URL to view budget in Trustpoint */
  trustpointBudgetUrl?: Maybe<Scalars['String']['output']>;
  /** URL to create a new draw in Trustpoint */
  trustpointNewDrawUrl?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export type DynamicContentCommunityEventEventTypeChoices =
  /** In Person */
  | 'IN_PERSON'
  /** Virtual */
  | 'VIRTUAL';

/** An enumeration. */
export type DynamicContentEventMarketStateChoices =
  /** Alaska */
  | 'AK'
  /** Alabama */
  | 'AL'
  /** Arkansas */
  | 'AR'
  /** Arizona */
  | 'AZ'
  /** California */
  | 'CA'
  /** Colorado */
  | 'CO'
  /** Connecticut */
  | 'CT'
  /** Delaware */
  | 'DE'
  /** Florida */
  | 'FL'
  /** Georgia */
  | 'GA'
  /** Hawaii */
  | 'HI'
  /** Iowa */
  | 'IA'
  /** Idaho */
  | 'ID'
  /** Illinois */
  | 'IL'
  /** Indiana */
  | 'IN'
  /** Kansas */
  | 'KS'
  /** Kentucky */
  | 'KY'
  /** Louisiana */
  | 'LA'
  /** Massachusetts */
  | 'MA'
  /** Maryland */
  | 'MD'
  /** Maine */
  | 'ME'
  /** Michigan */
  | 'MI'
  /** Minnesota */
  | 'MN'
  /** Missouri */
  | 'MO'
  /** Mississippi */
  | 'MS'
  /** Montana */
  | 'MT'
  /** North Carolina */
  | 'NC'
  /** North Dakota */
  | 'ND'
  /** Nebraska */
  | 'NE'
  /** New Hampshire */
  | 'NH'
  /** New Jersey */
  | 'NJ'
  /** New Mexico */
  | 'NM'
  /** Nevada */
  | 'NV'
  /** New York */
  | 'NY'
  /** Ohio */
  | 'OH'
  /** Oklahoma */
  | 'OK'
  /** Oregon */
  | 'OR'
  /** Pennsylvania */
  | 'PA'
  /** Rhode Island */
  | 'RI'
  /** South Carolina */
  | 'SC'
  /** South Dakota */
  | 'SD'
  /** Tennessee */
  | 'TN'
  /** Texas */
  | 'TX'
  /** Utah */
  | 'UT'
  /** Virginia */
  | 'VA'
  /** Vermont */
  | 'VT'
  /** Washington */
  | 'WA'
  /** West Virginia */
  | 'WV';

/** An enumeration. */
export type DynamicContentMarketingWidgetIconChoices =
  /** calendar */
  | 'CALENDAR'
  /** device */
  | 'DEVICE'
  /** megaphone */
  | 'MEGAPHONE';

/** An enumeration. */
export type DynamicContentMarketingWidgetImageChoices =
  /** calendar */
  | 'CALENDAR'
  /** device */
  | 'DEVICE'
  /** megaphone */
  | 'MEGAPHONE';

/** An enumeration. */
export type DynamicContentTrustedPartnerCategoryChoices =
  /** Attorney */
  | 'ATTORNEY'
  /** Contractor */
  | 'CONTRACTOR'
  /** Inspector */
  | 'INSPECTOR'
  /** Insurance */
  | 'INSURANCE'
  /** Lender */
  | 'LENDER'
  /** Other */
  | 'OTHER'
  /** Real Estate Agent */
  | 'REAL_ESTATE_AGENT'
  /** Tax Specialist */
  | 'TAX_SPECIALIST'
  /** Title */
  | 'TITLE';

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String']['output'];
  messages: Array<Scalars['String']['output']>;
};

/** GraphQL type for EventMarket */
export type EventMarketType = {
  __typename?: 'EventMarketType';
  city: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  state: DynamicContentEventMarketStateChoices;
};

export type ExtractEmailMutation = {
  __typename?: 'ExtractEmailMutation';
  status?: Maybe<Scalars['String']['output']>;
};

export type GoogleLoginMutation = {
  __typename?: 'GoogleLoginMutation';
  token?: Maybe<Scalars['String']['output']>;
};

/** Handle Incoming Place Object */
export type GooglePlaceType = {
  __typename?: 'GooglePlaceType';
  address: Scalars['String']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** GoogleTokenType */
export type GoogleTokenType = {
  __typename?: 'GoogleTokenType';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  emailExtractedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  invalidAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GoogleVerifyMutation = {
  __typename?: 'GoogleVerifyMutation';
  existing?: Maybe<Scalars['Boolean']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
};

export type LoanApplicationInput = {
  /** DEPRECATED. Not directly updateable from the client. */
  acquisitionFunding?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated After Repair Value of the property in dollars. */
  afterRepairValue?: InputMaybe<Scalars['Int']['input']>;
  /** Borrower Type: self | entity */
  borrower?: InputMaybe<Scalars['String']['input']>;
  /** Entity names. Null if borrower is self. */
  borrowerNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Cash available at the time of application. (i.e. 50-100) */
  cashAvailable?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED. Not directly updateable from the client. This is a calculated value. */
  cashToClose?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. This is a calculated value. */
  cashToCloseRangeMax?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. This is a calculated value. */
  cashToCloseRangeMin?: InputMaybe<Scalars['Float']['input']>;
  /** Amount already spent on construction in dollars. */
  constructionCostsSpent?: InputMaybe<Scalars['Int']['input']>;
  /** Preferred contact email of the borrower. Will update the user profile contact_email, but not the login email. */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /** Contract status at the time of application. (i.e. 'under-contract') */
  contractStatus?: InputMaybe<Scalars['String']['input']>;
  /** Credit Score ranges (i.e. 680-699, Above 750) */
  creditScore?: InputMaybe<Scalars['String']['input']>;
  /** Earnest money deposit on the property in dollars. */
  earnestMoneyDeposit?: InputMaybe<Scalars['Int']['input']>;
  /** Estimated As-Is value of the property in dollars. Used for refinance loans. */
  estimatedValue?: InputMaybe<Scalars['Int']['input']>;
  /** Existing loan principal balance in dollars. */
  existingLoanAmount?: InputMaybe<Scalars['Int']['input']>;
  expectedHoldPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  financingFees?: InputMaybe<Scalars['Float']['input']>;
  /** First name of the borrower. Will update the user profile first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Number of flips completed. The lower end of the range. (i.e. 3 if 3-9) */
  flipsCompleted?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  grossProfitPotential?: InputMaybe<Scalars['Int']['input']>;
  /** Expected hold period in months. */
  holdPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  hsDealId?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  initialFunding?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  interestRate?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. No longer used. Left in the schema for backwards compatibility. */
  internalLoanNumber?: InputMaybe<Scalars['Int']['input']>;
  /** Last name of the borrower. Will update the user profile last name. */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED. Not directly updateable from the client. Use first_name and last_name instead. */
  legalName?: InputMaybe<Scalars['String']['input']>;
  /** Indicate if a leverage discount should be applied. */
  leverageDiscount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Selected loan product type. (i.e. 'standard') */
  loanProduct?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  loanTerm?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED. Not directly updateable from the client. This is a calculated value. */
  loanToCost?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  loanToCostAtCompletion?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Never directly updated from the client. Use loan_product instead. */
  loanType?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  monthlyHoldingCosts?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. This is a calculated value. */
  monthlyPayment?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. Estimated by the backend. */
  oneTimeCosts?: InputMaybe<Scalars['Float']['input']>;
  /** Purchase date of the property. Used in refinance. ISO 8601 format. */
  originalPurchaseDate?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  originationFee?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  originationRate?: InputMaybe<Scalars['Float']['input']>;
  /** Preferred contact phone number of the borrower. Will update the user profile phone number. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  profitPotential?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  propertyStatus?: InputMaybe<Scalars['String']['input']>;
  /** Purchase price of the property in dollars excluding closing costs or fees. Either anticipated or at the time of acquistion in the case of a refinance. */
  purchasePrice?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  rehabCostPerSquareFoot?: InputMaybe<Scalars['Float']['input']>;
  /** Total estimated rehab cost of the property in dollars. */
  rehabEstimate?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED. Legacy input. */
  rehabFunding?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  rent?: InputMaybe<Scalars['Int']['input']>;
  /** Number of rentals owned. The lower end of the range. (i.e. 3 if 3-9) */
  rentalProperties?: InputMaybe<Scalars['Int']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  rewardsCredit?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  rewardsTier?: InputMaybe<Scalars['String']['input']>;
  /** DEPRECATED. Not directly updateable from the client. */
  roiDealScore?: InputMaybe<Scalars['String']['input']>;
  /** Set to 'Submitted' to submit the application, otherwise leave blank. */
  status?: InputMaybe<Scalars['String']['input']>;
  /** ISO 8601 formatted target close date for the loan application. */
  targetCloseDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** DEPRECATED. Not directly updateable from the client. This is a calculated value. */
  totalCostBasis?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. This is a calculated value. */
  totalLoanAmount?: InputMaybe<Scalars['Float']['input']>;
  /** DEPRECATED. Not directly updateable from the client. This is a calculated value. */
  transactionCosts?: InputMaybe<Scalars['Int']['input']>;
};

/** Loan Application Related Stats */
export type LoanApplicationStatsType = {
  __typename?: 'LoanApplicationStatsType';
  /** Total Loan Apps that are not Current, Expired or Archived */
  totalActiveLoanApps?: Maybe<Scalars['Int']['output']>;
};

export type LoanApplicationType = {
  __typename?: 'LoanApplicationType';
  acquisitionFunding?: Maybe<Scalars['Int']['output']>;
  afterRepairValue?: Maybe<Scalars['Int']['output']>;
  /** The associated analysis. */
  analysis?: Maybe<AnalysisType>;
  assetCashToClose?: Maybe<Scalars['Float']['output']>;
  assetReportFunds?: Maybe<Scalars['Float']['output']>;
  assetReportStatus?: Maybe<Scalars['String']['output']>;
  borrower?: Maybe<Scalars['String']['output']>;
  borrowerNames?: Maybe<Array<Scalars['String']['output']>>;
  cashAvailable?: Maybe<Scalars['String']['output']>;
  cashToClose?: Maybe<Scalars['Float']['output']>;
  cashToCloseRangeMax?: Maybe<Scalars['Float']['output']>;
  cashToCloseRangeMin?: Maybe<Scalars['Float']['output']>;
  constructionCostsSpent?: Maybe<Scalars['Int']['output']>;
  contractStatus?: Maybe<Scalars['String']['output']>;
  /** The sum of the purchase price and the rehab estimate */
  costBasis?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** Date application submitted to Backflip */
  createdOn: Scalars['DateTime']['output'];
  creditScore?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The cash value of discounts (non-rewards) applied to the loan at time of submission */
  discountCredit?: Maybe<Scalars['Float']['output']>;
  /** List of discounts available or applied to the loan application */
  discounts?: Maybe<Array<Maybe<LoanDiscountType>>>;
  /** The amount of earnest money deposited by the borrower */
  earnestMoneyDeposit?: Maybe<Scalars['Int']['output']>;
  estimatedCashToBorrower?: Maybe<Scalars['Float']['output']>;
  /** The cash to close minus any closing credits */
  estimatedCashToClose?: Maybe<Scalars['Float']['output']>;
  estimatedValue: Scalars['Int']['output'];
  existingLoanAmount?: Maybe<Scalars['Float']['output']>;
  expectedHoldPeriod?: Maybe<Scalars['Int']['output']>;
  /** Link to portal for deal document upload */
  fileUploadPortalLink?: Maybe<Scalars['String']['output']>;
  /** Sum of all fees associated with loan */
  financingFee?: Maybe<Scalars['Float']['output']>;
  financingFees?: Maybe<Scalars['Float']['output']>;
  flipsCompleted?: Maybe<Scalars['Int']['output']>;
  /** The difference between ARV and cost basis */
  grossProfit?: Maybe<Scalars['Float']['output']>;
  grossProfitPotential?: Maybe<Scalars['Int']['output']>;
  holdPeriod?: Maybe<Scalars['Int']['output']>;
  hsDealId?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  initialFunding?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  internalLoanNumber?: Maybe<Scalars['Int']['output']>;
  isDeleted: Scalars['Boolean']['output'];
  isPerkQualified?: Maybe<Scalars['Boolean']['output']>;
  legalName?: Maybe<Scalars['String']['output']>;
  leverageDiscount?: Maybe<Scalars['Boolean']['output']>;
  loanProduct?: Maybe<Scalars['String']['output']>;
  loanTerm: Scalars['Int']['output'];
  loanToCost?: Maybe<Scalars['Float']['output']>;
  loanToCostAtClose?: Maybe<Scalars['Float']['output']>;
  loanToCostAtCompletion?: Maybe<Scalars['Float']['output']>;
  loanType: Scalars['String']['output'];
  mobileShortUrl?: Maybe<ShortUrlType>;
  monthlyHoldingCosts?: Maybe<Scalars['Float']['output']>;
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  oneTimeCosts?: Maybe<Scalars['Float']['output']>;
  originalPurchaseDate?: Maybe<Scalars['Date']['output']>;
  originationFee?: Maybe<Scalars['Float']['output']>;
  originationRate?: Maybe<Scalars['Float']['output']>;
  profitPotential?: Maybe<Scalars['Float']['output']>;
  /** The real estate property. */
  property: PropertyType;
  propertyStatus: Scalars['String']['output'];
  purchasePrice: Scalars['Int']['output'];
  rehabBudget?: Maybe<RehabBudgetType>;
  rehabCostPerSquareFoot?: Maybe<Scalars['Float']['output']>;
  rehabEstimate?: Maybe<Scalars['Int']['output']>;
  rehabFunding?: Maybe<Scalars['Int']['output']>;
  rent: Scalars['Int']['output'];
  rentalProperties?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Scalars['JSONString']['output']>;
  returnOnInvestment?: Maybe<Scalars['Float']['output']>;
  rewardsCredit?: Maybe<Scalars['Float']['output']>;
  rewardsTier?: Maybe<Scalars['String']['output']>;
  roiDealScore?: Maybe<Scalars['String']['output']>;
  /** The loan status defined by loan app or Hubspot deal */
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  targetCloseDate?: Maybe<Scalars['Date']['output']>;
  totalCostBasis?: Maybe<Scalars['Float']['output']>;
  totalLoanAmount?: Maybe<Scalars['Float']['output']>;
  totalRepaidLoans?: Maybe<Scalars['Int']['output']>;
  transactionCosts?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** User applying for the loan. */
  user: UserType;
};

/** Dashboard user-facing status options. */
export type LoanDashboardStatus =
  | 'active'
  | 'archived'
  | 'quote'
  | 'repaid';

export type LoanDiscountType = {
  __typename?: 'LoanDiscountType';
  /** Populated if the discount type affects BPS */
  discountBps?: Maybe<Scalars['Float']['output']>;
  /** Indicates how the discount is to be applied */
  discountType: Scalars['String']['output'];
  /** The timestamp the discount expires */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  feeDiscount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  modifiedFee?: Maybe<Scalars['Float']['output']>;
  modifiedRate?: Maybe<Scalars['Float']['output']>;
  originalFee?: Maybe<Scalars['Float']['output']>;
  originalRate?: Maybe<Scalars['Float']['output']>;
  /** For tracking discounts back to specific campaigns */
  promotion?: Maybe<Scalars['String']['output']>;
  rateDiscount?: Maybe<Scalars['Float']['output']>;
  /** Whether the discount is EXPIRED, APPLIED (on a submitted loan), or ACTIVE (elibigle to be applied) */
  status?: Maybe<Scalars['String']['output']>;
};

export type LoanInfoType = {
  __typename?: 'LoanInfoType';
  /** Date the loan was closed */
  closeDate?: Maybe<Scalars['DateTime']['output']>;
  /** Extended loan maturity date */
  extendedMaturity?: Maybe<Scalars['Date']['output']>;
  /** Combined interest rate */
  interestRate?: Maybe<Scalars['String']['output']>;
  /** Total loan amount (combined A and B pieces) */
  loanAmount?: Maybe<Scalars['Float']['output']>;
  /** Original loan maturity date */
  originalMaturity?: Maybe<Scalars['Date']['output']>;
  /** Capital product type */
  product?: Maybe<Scalars['String']['output']>;
};

/** Loan product options. */
export type LoanProduct =
  | 'double_double'
  | 'refinance_rehab'
  | 'standard'
  | 'zero_gravity';

export type LoanProductDetailsType = {
  __typename?: 'LoanProductDetailsType';
  interestRate?: Maybe<Scalars['Float']['output']>;
  interestRateFormatted?: Maybe<Scalars['String']['output']>;
  loanToCostClosing?: Maybe<Scalars['Float']['output']>;
  loanToCostClosingFormatted?: Maybe<Scalars['String']['output']>;
  loanToCostCompletion?: Maybe<Scalars['Float']['output']>;
  loanToCostCompletionFormatted?: Maybe<Scalars['String']['output']>;
  originationFee?: Maybe<Scalars['Float']['output']>;
  originationFeeFormatted?: Maybe<Scalars['String']['output']>;
};

export type LoanProductRequirementType = {
  __typename?: 'LoanProductRequirementType';
  /** Descriptive label of the requirement */
  label?: Maybe<Scalars['String']['output']>;
  /** True if the current user meets the requirement */
  valid?: Maybe<Scalars['Boolean']['output']>;
  /** Current user value for the requirement. (Suitable for display.) */
  value?: Maybe<Scalars['String']['output']>;
};

export type LoanProductType = {
  __typename?: 'LoanProductType';
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<LoanProductDetailsType>;
  /** Human friendly display name */
  displayName?: Maybe<Scalars['String']['output']>;
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Loan product type */
  productType?: Maybe<Scalars['String']['output']>;
  requirements?: Maybe<Array<Maybe<LoanProductRequirementType>>>;
};

/** LoanProfileType */
export type LoanProfileType = {
  __typename?: 'LoanProfileType';
  borrower?: Maybe<Scalars['String']['output']>;
  borrowerNames?: Maybe<Array<Scalars['String']['output']>>;
  cashAvailable?: Maybe<Scalars['String']['output']>;
  creditScore?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  propertiesFlipped?: Maybe<Scalars['String']['output']>;
  rentalsOwned?: Maybe<Scalars['String']['output']>;
};

/** A top-level namespace type to contain loan-related queries. */
export type LoanQueries = {
  __typename?: 'LoanQueries';
  /**
   *
   *     Get a Loan Application by its id.
   *
   */
  getApplication: LoanType;
  getApplications: BfLoanApplicationTypeConnection;
};


/** A top-level namespace type to contain loan-related queries. */
export type LoanQueriesGetApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


/** A top-level namespace type to contain loan-related queries. */
export type LoanQueriesGetApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userStatus?: InputMaybe<Scalars['String']['input']>;
};

/** Possible Loan / Loan App states. A blend of zion and hubspot state. */
export type LoanStatus =
  | 'application_received'
  | 'application_started'
  | 'appraisal_completed'
  | 'appraisal_ordered'
  | 'approved'
  | 'archived'
  | 'clear_to_close'
  | 'current'
  | 'denied'
  | 'expired'
  | 'final_review'
  | 'initial_processing'
  | 'processing'
  | 'repaid'
  | 'request_received'
  | 'request_submitted'
  | 'sold'
  | 'started'
  | 'submitted';

export type LoanTaskType = {
  __typename?: 'LoanTaskType';
  /** Should the task be visible to the user. */
  isVisible: Scalars['Boolean']['output'];
  /** Should the task cause notification. (i.e. the red notification bug) */
  shouldNotify: Scalars['Boolean']['output'];
  /** Type of task. Dictates copy, etc in the UI. */
  taskType: TaskType;
};

export type LoanType = {
  id: Scalars['ID']['output'];
};

export type LoginMutation = {
  __typename?: 'LoginMutation';
  token?: Maybe<Scalars['String']['output']>;
};

/** Latest Market Data Fields for a given Location */
export type MarketDataType = {
  __typename?: 'MarketDataType';
  avgSaleToList?: Maybe<Scalars['Float']['output']>;
  avgSaleToListMom?: Maybe<Scalars['Float']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  homesSold?: Maybe<Scalars['Float']['output']>;
  homesSoldMom?: Maybe<Scalars['Float']['output']>;
  inventory?: Maybe<Scalars['Float']['output']>;
  inventoryMom?: Maybe<Scalars['Float']['output']>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  medianDom?: Maybe<Scalars['Float']['output']>;
  medianDomMom?: Maybe<Scalars['Float']['output']>;
  medianSalePrice?: Maybe<Scalars['Float']['output']>;
  medianSalePriceMom?: Maybe<Scalars['Float']['output']>;
  newListings?: Maybe<Scalars['Float']['output']>;
  newListingsMom?: Maybe<Scalars['Float']['output']>;
  periodBegin?: Maybe<Scalars['String']['output']>;
  periodEnd?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type MarketingWidgetType = {
  __typename?: 'MarketingWidgetType';
  createdAt: Scalars['DateTime']['output'];
  ctaCopy?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** External URL or relative path within Backflip app */
  externalLink?: Maybe<Scalars['String']['output']>;
  forceActive?: Maybe<Scalars['Boolean']['output']>;
  heading: Scalars['String']['output'];
  icon: DynamicContentMarketingWidgetIconChoices;
  iconCopy: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  image?: Maybe<DynamicContentMarketingWidgetImageChoices>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** A single task within a milestone. */
export type MilestoneTaskType = {
  __typename?: 'MilestoneTaskType';
  dealOrIndividual?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  estimatedTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  taskType?: Maybe<Scalars['String']['output']>;
  taskUrl?: Maybe<Scalars['String']['output']>;
};

/** A milestone in the loan application process. */
export type MilestoneType = {
  __typename?: 'MilestoneType';
  completedDate?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  percentageDone?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tasks: Array<MilestoneTaskType>;
};

export type MonthlyPaymentType = {
  __typename?: 'MonthlyPaymentType';
  /** Loan number with optional piece suffix (-A or -B) */
  loanNumber?: Maybe<Scalars['String']['output']>;
  /** Monthly interest payment amount */
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Loan servicer */
  servicer?: Maybe<Scalars['String']['output']>;
  /** Link to servicer portal */
  servicerLink?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  appleLogin?: Maybe<AppleLoginMutation>;
  changePassword?: Maybe<ChangePasswordMutation>;
  /** Create a new analysis */
  createAnalysis?: Maybe<CreateAnalysisMutation>;
  createAnalysisComp?: Maybe<CreateAnalysisCompMutation>;
  /** Create/Update Analysis Feedback */
  createAnalysisFeedback?: Maybe<CreateAnalysisFeedbackMutation>;
  /** Create a new loan application */
  createLoanApplication?: Maybe<CreateLoanApplicationMutation>;
  createPreApprovalRequest?: Maybe<CreatePreApprovalRequestMutation>;
  /** Share an Existing Analysis */
  createShareableAnalysis?: Maybe<CreateShareableAnalysisMutation>;
  /** Create a Credit Report Mutation to Retrieve Credit Report Data, Save it, and Send it to HubSpot */
  creditReportMutation?: Maybe<CreditReportMutation>;
  deleteAccount?: Maybe<DeleteAccountMutation>;
  deleteAnalysis?: Maybe<DeleteAnalysisMutation>;
  deleteLoanApplication?: Maybe<DeleteLoanApplicationMutation>;
  disconnectMyLeads?: Maybe<DisconnectMyLeadsMutation>;
  extractEmail?: Maybe<ExtractEmailMutation>;
  googleLogin?: Maybe<GoogleLoginMutation>;
  googleVerify?: Maybe<GoogleVerifyMutation>;
  login?: Maybe<LoginMutation>;
  register?: Maybe<RegisterMutation>;
  /** Mutation to register a user device for push notifications. */
  registerDevice?: Maybe<RegisterDeviceMutation>;
  resetPassword?: Maybe<ResetPasswordMutation>;
  sendNotification?: Maybe<SendNotificationMutation>;
  /** Change Analysis Favorite */
  setAnalysisFavorite?: Maybe<SetAnalysisFavoriteMutation>;
  setAnalysisNotifications?: Maybe<SetAnalysisNotificationsMutation>;
  setLoanProduct?: Maybe<SetLoanProductMutation>;
  setRehabBudgetInitialPropertyType?: Maybe<SetBudgetInitialPropertyTypeMutation>;
  submitRehabBudget?: Maybe<SubmitRehabBudgetMutation>;
  unArchiveApplication: UnArchiveApplicationMutation;
  /** Mutation to delete a user device. */
  unregisterDevice?: Maybe<UnregisterDeviceMutation>;
  /** Update an existing analysis */
  updateAnalysis?: Maybe<UpdateAnalysisMutation>;
  /** Mutation to Update a Pre-Existing Analysis with a New Set of Comps */
  updateAnalysisComps?: Maybe<UpdateAnalysisCompsMutation>;
  /** Update an existing loan application */
  updateLoanApplication?: Maybe<UpdateLoanApplicationMutation>;
  updatePrimaryDrawsContact?: Maybe<UpdatePrimaryDrawsContactMutation>;
  updateRehabBudget?: Maybe<UpdateRehabBudgetMutation>;
  updateRehabBudgetLineItem?: Maybe<UpdateBudgetLineItemMutation>;
  updateRehabBudgetPropertyDetails?: Maybe<UpdateBudgetPropertyDetailsMutation>;
  /** Retrieve Market Data for a User by Latitude and Longitude, Zip or City and State */
  updateUserMarketData?: Maybe<UpdateUserMarketData>;
  updateUserProfile?: Maybe<UserProfileMutation>;
  upsertBuyBox?: Maybe<BuyBoxMutation>;
  upsertPreQual?: Maybe<PreQualificationMutationPayload>;
};


export type MutationAppleLoginArgs = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  serviceType: Scalars['String']['input'];
  utm?: InputMaybe<UtmInput>;
};


export type MutationChangePasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationCreateAnalysisArgs = {
  area?: InputMaybe<Scalars['Int']['input']>;
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  placeId: Scalars['String']['input'];
};


export type MutationCreateAnalysisCompArgs = {
  address: Scalars['String']['input'];
  analysisId: Scalars['ID']['input'];
};


export type MutationCreateAnalysisFeedbackArgs = {
  analysisId: Scalars['ID']['input'];
  analysisInput: AnalysisFeedbackInput;
};


export type MutationCreateLoanApplicationArgs = {
  analysisId?: InputMaybe<Scalars['ID']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePreApprovalRequestArgs = {
  phoneNumber: Scalars['String']['input'];
  propertyId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateShareableAnalysisArgs = {
  analysisId: Scalars['ID']['input'];
};


export type MutationCreditReportMutationArgs = {
  dateOfBirth: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  loanId: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
};


export type MutationDeleteAccountArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteAnalysisArgs = {
  analysisId: Scalars['ID']['input'];
};


export type MutationDeleteLoanApplicationArgs = {
  loanApplicationId: Scalars['ID']['input'];
};


export type MutationDisconnectMyLeadsArgs = {
  input: DisconnectMyLeadsInput;
};


export type MutationGoogleLoginArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preQual?: InputMaybe<PreQualInput>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  scopes: Array<InputMaybe<Scalars['String']['input']>>;
  serviceType: Scalars['String']['input'];
  utm?: InputMaybe<UtmInput>;
};


export type MutationGoogleVerifyArgs = {
  code: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
  scopes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preQual?: InputMaybe<PreQualInput>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmInput>;
};


export type MutationRegisterDeviceArgs = {
  deviceType: Scalars['String']['input'];
  notificationToken: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendNotificationArgs = {
  body: Scalars['String']['input'];
  emails: Array<InputMaybe<Scalars['String']['input']>>;
  title: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetAnalysisFavoriteArgs = {
  analysisId: Scalars['ID']['input'];
  isFavorite: Scalars['Boolean']['input'];
};


export type MutationSetAnalysisNotificationsArgs = {
  analysisId: Scalars['ID']['input'];
  enableNotifications: Scalars['Boolean']['input'];
};


export type MutationSetLoanProductArgs = {
  productType: Scalars['String']['input'];
};


export type MutationSetRehabBudgetInitialPropertyTypeArgs = {
  setBudgetPropertyTypeInput: SetBudgetPropertyTypeInput;
};


export type MutationSubmitRehabBudgetArgs = {
  submitRehabBudgetInput: SubmitRehabBudgetInput;
};


export type MutationUnArchiveApplicationArgs = {
  input: UnArchiveInput;
};


export type MutationUnregisterDeviceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAnalysisArgs = {
  analysisId: Scalars['ID']['input'];
  analysisInput: AnalysisInput;
};


export type MutationUpdateAnalysisCompsArgs = {
  analysisCompInput: AnalysisCompInput;
  analysisId: Scalars['ID']['input'];
};


export type MutationUpdateLoanApplicationArgs = {
  loanApplicationId: Scalars['ID']['input'];
  loanApplicationInput: LoanApplicationInput;
};


export type MutationUpdatePrimaryDrawsContactArgs = {
  drawsContactInput: UpdatePrimaryDrawsContactInput;
};


export type MutationUpdateRehabBudgetArgs = {
  rehabBudgetId: Scalars['ID']['input'];
  rehabBudgetInput: UpdateRehabBudgetInput;
};


export type MutationUpdateRehabBudgetLineItemArgs = {
  lineItemInput: UpsertBudgetLineItemInput;
};


export type MutationUpdateRehabBudgetPropertyDetailsArgs = {
  propertyDetailInput: UpdateBudgetPropertyDetailsInput;
};


export type MutationUpdateUserMarketDataArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserProfileArgs = {
  input: UserProfileInput;
};


export type MutationUpsertBuyBoxArgs = {
  areaMax?: InputMaybe<Scalars['Int']['input']>;
  areaMin?: InputMaybe<Scalars['Int']['input']>;
  arvMax?: InputMaybe<Scalars['Int']['input']>;
  arvMin?: InputMaybe<Scalars['Int']['input']>;
  baths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  beds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  profitMin?: InputMaybe<Scalars['Int']['input']>;
  yearBuiltMax?: InputMaybe<Scalars['Int']['input']>;
  yearBuiltMin?: InputMaybe<Scalars['Int']['input']>;
  zipCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpsertPreQualArgs = {
  input: PreQualificationMutationInput;
};

export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** PointTransactionType */
export type PointTransactionType = {
  __typename?: 'PointTransactionType';
  amount: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  /** The dollar value of the balance */
  balanceDollarValue?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  spent: Scalars['Int']['output'];
};

export type PostCloseType = {
  __typename?: 'PostCloseType';
  /** Draws budget information */
  drawsBudget?: Maybe<DrawsBudgetType>;
  /** Extension request form link */
  extensionRequestLink?: Maybe<Scalars['String']['output']>;
  /** Loan details */
  loanInfo?: Maybe<LoanInfoType>;
  /** Monthly payment details */
  monthlyPayments?: Maybe<Array<Maybe<MonthlyPaymentType>>>;
  /** Payoff request form link */
  payoffRequestLink?: Maybe<Scalars['String']['output']>;
  /** Property information */
  propertyInfo?: Maybe<PropertyInfoType>;
  /** Team member information */
  team?: Maybe<TeamInfoType>;
};

export type PreApprovalRequestType = {
  __typename?: 'PreApprovalRequestType';
  /** The PreApproval Request Identifier */
  id?: Maybe<Scalars['UUID']['output']>;
  /** The phone number provided for contact in the pre-approval request. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** The property associated with this pre-approval request. */
  property?: Maybe<PropertyType>;
};

export type PreQualInput = {
  borrower?: InputMaybe<Scalars['String']['input']>;
  borrowerNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cashAvailable?: InputMaybe<Scalars['String']['input']>;
  creditScore?: InputMaybe<Scalars['String']['input']>;
  declinedContact?: InputMaybe<Scalars['Boolean']['input']>;
  intentStatus?: InputMaybe<Scalars['String']['input']>;
  propertiesFlipped?: InputMaybe<Scalars['String']['input']>;
  rentalsOwned?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
};

export type PreQualificationMutationInput = {
  borrower?: InputMaybe<Scalars['String']['input']>;
  borrowerNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cashAvailable?: InputMaybe<Scalars['String']['input']>;
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  creditScore?: InputMaybe<Scalars['String']['input']>;
  declinedContact?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  intentStatus?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  propertiesFlipped?: InputMaybe<Scalars['String']['input']>;
  rentalsOwned?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PreQualificationMutationPayload = {
  __typename?: 'PreQualificationMutationPayload';
  borrower?: Maybe<Scalars['String']['output']>;
  borrowerNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cashAvailable?: Maybe<Scalars['String']['output']>;
  clientMutationId?: Maybe<Scalars['String']['output']>;
  creditScore?: Maybe<Scalars['String']['output']>;
  declinedContact?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  intentStatus?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  propertiesFlipped?: Maybe<Scalars['String']['output']>;
  rentalsOwned?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Scalars['String']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type PreQualificationType = {
  __typename?: 'PreQualificationType';
  borrower?: Maybe<Scalars['String']['output']>;
  borrowerNames?: Maybe<Array<Scalars['String']['output']>>;
  cashAvailable?: Maybe<Scalars['String']['output']>;
  creditScore?: Maybe<Scalars['String']['output']>;
  declinedContact?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  intentStatus?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  propertiesFlipped?: Maybe<Scalars['String']['output']>;
  rentalsOwned?: Maybe<Scalars['String']['output']>;
  timeline?: Maybe<Scalars['String']['output']>;
};

export type ProductType = {
  __typename?: 'ProductType';
  allowsRural?: Maybe<Scalars['Boolean']['output']>;
  cashToClose?: Maybe<Scalars['Int']['output']>;
  cashToCloseRangeMax?: Maybe<Scalars['Float']['output']>;
  cashToCloseRangeMin?: Maybe<Scalars['Float']['output']>;
  creditScore?: Maybe<Scalars['Int']['output']>;
  flips?: Maybe<Scalars['Int']['output']>;
  holdPeriod?: Maybe<Scalars['Int']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  interestRateBreakdown?: Maybe<Array<Maybe<AdjustmentBreakdown>>>;
  isEligible?: Maybe<Scalars['Boolean']['output']>;
  isSelectable?: Maybe<Scalars['Boolean']['output']>;
  loanToAiv?: Maybe<Scalars['Float']['output']>;
  loanToArv?: Maybe<Scalars['Float']['output']>;
  loanToCostAtClosing?: Maybe<Scalars['Float']['output']>;
  loanToCostAtCompletion?: Maybe<Scalars['Float']['output']>;
  nonLicensedStates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  originationFee?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<Scalars['String']['output']>;
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  qualifiedCreditScore?: Maybe<Scalars['Int']['output']>;
  qualifiedExperience?: Maybe<Scalars['Int']['output']>;
  qualifiedHoldPeriod?: Maybe<Scalars['Int']['output']>;
  qualifiedLoanAmount?: Maybe<Scalars['Int']['output']>;
  qualifiedMaxLoanAmount?: Maybe<Scalars['Int']['output']>;
  qualifiedPurchasePrice?: Maybe<Scalars['Int']['output']>;
  qualifiedReturnOnInvestment?: Maybe<Scalars['Float']['output']>;
  returnOnInvestment?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  totalLoanAmount?: Maybe<Scalars['Float']['output']>;
};

export type PropertyInfoType = {
  __typename?: 'PropertyInfoType';
  /** Property street address */
  address?: Maybe<Scalars['String']['output']>;
  /** Property city */
  city?: Maybe<Scalars['String']['output']>;
  /** Property state */
  state?: Maybe<Scalars['String']['output']>;
  /** Property ZIP code */
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** PropertyType */
export type PropertyType = {
  __typename?: 'PropertyType';
  appliances?: Maybe<Array<Scalars['String']['output']>>;
  area?: Maybe<Scalars['Int']['output']>;
  bathrooms?: Maybe<Scalars['Float']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  daysOnMarket?: Maybe<Scalars['Int']['output']>;
  estimatedValue?: Maybe<Scalars['Int']['output']>;
  fullAddress: Scalars['String']['output'];
  /** Single display image url */
  heroImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  latLongPrecision?: Maybe<Scalars['String']['output']>;
  latestSaleDate?: Maybe<Scalars['Date']['output']>;
  latestSalePrice?: Maybe<Scalars['Float']['output']>;
  /** Latitude of the property */
  latitude?: Maybe<Scalars['String']['output']>;
  legalSubdivision?: Maybe<Scalars['String']['output']>;
  /** Longitude of the property */
  longitude?: Maybe<Scalars['String']['output']>;
  lotSize?: Maybe<Scalars['Float']['output']>;
  marketPpsf?: Maybe<Scalars['Int']['output']>;
  media?: Maybe<Array<Scalars['String']['output']>>;
  placeId?: Maybe<Scalars['String']['output']>;
  propertyId?: Maybe<Scalars['String']['output']>;
  propertyType?: Maybe<Scalars['String']['output']>;
  schoolElementary?: Maybe<Scalars['String']['output']>;
  schoolHigh?: Maybe<Scalars['String']['output']>;
  schoolMiddle?: Maybe<Scalars['String']['output']>;
  secondLatestSaleDate?: Maybe<Scalars['Date']['output']>;
  secondLatestSalePrice?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stories?: Maybe<Scalars['Int']['output']>;
  street: Scalars['String']['output'];
  subProvider?: Maybe<Scalars['String']['output']>;
  taxAnnualAmount?: Maybe<Scalars['Float']['output']>;
  taxAnnualValue?: Maybe<Scalars['Float']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  water?: Maybe<Scalars['String']['output']>;
  waterfront?: Maybe<Scalars['Boolean']['output']>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
  zipcode: Scalars['String']['output'];
  zoningCode?: Maybe<Scalars['String']['output']>;
  zoningDescription?: Maybe<Scalars['String']['output']>;
};

/** Root Zion Queries */
export type Query = {
  __typename?: 'Query';
  accountExists?: Maybe<AccountExistsType>;
  analyses?: Maybe<Array<AnalysisType>>;
  analysis?: Maybe<AnalysisType>;
  analysisComp?: Maybe<AnalysisCompType>;
  analysisStats?: Maybe<AnalysisStatsType>;
  appShortLinkRedirect?: Maybe<ShortUrlType>;
  badges?: Maybe<BadgesType>;
  capitalProducts?: Maybe<Array<Maybe<ProductType>>>;
  communityEvents?: Maybe<Array<Maybe<CommunityEventType>>>;
  compQueryPreference?: Maybe<CompQueryPreferenceType>;
  currentPreQualification?: Maybe<PreQualificationType>;
  googlePlaces?: Maybe<Array<Maybe<GooglePlaceType>>>;
  loanApplication?: Maybe<LoanApplicationType>;
  loanApplicationStats?: Maybe<LoanApplicationStatsType>;
  loanApplications?: Maybe<Array<Maybe<LoanApplicationType>>>;
  loanApplicationsCount?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use capitalProducts instead */
  loanProducts?: Maybe<Array<Maybe<LoanProductType>>>;
  /**
   *
   *     A top-level namespace type to contain loan-related queries.
   *
   */
  loanQueries?: Maybe<LoanQueries>;
  marketDataQuery?: Maybe<MarketDataType>;
  marketingWidget?: Maybe<MarketingWidgetType>;
  me?: Maybe<UserType>;
  preApprovalRequest?: Maybe<PreApprovalRequestType>;
  property?: Maybe<PropertyType>;
  redfinAutocomplete?: Maybe<Array<Maybe<RedfinAutocompleteType>>>;
  rehabBudget?: Maybe<RehabBudgetType>;
  rewardsProgramDetails?: Maybe<RewardsProgramDetailsType>;
  sourcedProperty?: Maybe<SourcedPropertyType>;
  tokenData?: Maybe<UserType>;
  trustedPartners?: Maybe<Array<Maybe<TrustedPartnerType>>>;
  userDevice?: Maybe<UserDeviceType>;
  userDevices?: Maybe<Array<Maybe<UserDeviceType>>>;
};


/** Root Zion Queries */
export type QueryAccountExistsArgs = {
  email: Scalars['String']['input'];
};


/** Root Zion Queries */
export type QueryAnalysesArgs = {
  buyBoxId?: InputMaybe<Scalars['ID']['input']>;
  onlyFavorites?: InputMaybe<Scalars['Boolean']['input']>;
  onlySourced?: InputMaybe<Scalars['Boolean']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Zion Queries */
export type QueryAnalysisArgs = {
  analysisId: Scalars['ID']['input'];
};


/** Root Zion Queries */
export type QueryAnalysisCompArgs = {
  analysisId?: InputMaybe<Scalars['ID']['input']>;
  arvCompId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root Zion Queries */
export type QueryAnalysisStatsArgs = {
  intervalDays?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Zion Queries */
export type QueryAppShortLinkRedirectArgs = {
  shortCode?: InputMaybe<Scalars['String']['input']>;
};


/** Root Zion Queries */
export type QueryCapitalProductsArgs = {
  loanId?: InputMaybe<Scalars['ID']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Zion Queries */
export type QueryCompQueryPreferenceArgs = {
  analysisId: Scalars['ID']['input'];
  default?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root Zion Queries */
export type QueryGooglePlacesArgs = {
  address: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
};


/** Root Zion Queries */
export type QueryLoanApplicationArgs = {
  loanId: Scalars['ID']['input'];
};


/** Root Zion Queries */
export type QueryLoanApplicationsArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
  ordering?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


/** Root Zion Queries */
export type QueryMarketDataQueryArgs = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};


/** Root Zion Queries */
export type QueryPropertyArgs = {
  propertyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root Zion Queries */
export type QueryRedfinAutocompleteArgs = {
  region: Scalars['String']['input'];
};


/** Root Zion Queries */
export type QueryRehabBudgetArgs = {
  loanApplicationId?: InputMaybe<Scalars['ID']['input']>;
  rehabBudgetId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root Zion Queries */
export type QuerySourcedPropertyArgs = {
  sourcedPropertyId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root Zion Queries */
export type QueryTokenDataArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


/** Root Zion Queries */
export type QueryTrustedPartnersArgs = {
  loanApplicationId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root Zion Queries */
export type QueryUserDeviceArgs = {
  id: Scalars['ID']['input'];
};

/** Type for the Redfin Autocomplete API */
export type RedfinAutocompleteType = {
  __typename?: 'RedfinAutocompleteType';
  region?: Maybe<Scalars['String']['output']>;
};

/** Mutation to register a user device for push notifications. */
export type RegisterDeviceMutation = {
  __typename?: 'RegisterDeviceMutation';
  device?: Maybe<UserDeviceType>;
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type RegisterMutation = {
  __typename?: 'RegisterMutation';
  token?: Maybe<Scalars['String']['output']>;
};

export type RehabBudgetType = {
  __typename?: 'RehabBudgetType';
  contingencyAmount: Scalars['Decimal']['output'];
  contingencyValue?: Maybe<Scalars['Decimal']['output']>;
  hasModifiedPropertyDetails?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  initialPropertyDetails?: Maybe<BudgetPropertyDetailsType>;
  lineItems?: Maybe<Array<Maybe<BudgetLineItemType>>>;
  modifiedPropertyDetails?: Maybe<BudgetPropertyDetailsType>;
  primaryDrawsContact?: Maybe<BudgetContactDetailsType>;
  projectDescription?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Decimal']['output']>;
  totalBudget?: Maybe<Scalars['Decimal']['output']>;
};

export type ResetPasswordMutation = {
  __typename?: 'ResetPasswordMutation';
  token?: Maybe<Scalars['String']['output']>;
};

export type RewardsProgramDetailsType = {
  __typename?: 'RewardsProgramDetailsType';
  closesToPoints?: Maybe<Array<Maybe<ClosesToRewardsPointsType>>>;
  pointsDollarConversion?: Maybe<Scalars['Int']['output']>;
  pointsForReferralClose?: Maybe<Scalars['Int']['output']>;
  tiers?: Maybe<Array<Maybe<RewardsProgramTierDetailsType>>>;
};

export type RewardsProgramTierDetailsType = {
  __typename?: 'RewardsProgramTierDetailsType';
  interestRateDiscount?: Maybe<Scalars['Float']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  minPointsRequired?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  origFeeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type SendNotificationMutation = {
  __typename?: 'SendNotificationMutation';
  failedEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sentToEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sentViaExpo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sentViaOnesignal?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Change Analysis Favorite */
export type SetAnalysisFavoriteMutation = {
  __typename?: 'SetAnalysisFavoriteMutation';
  analysis?: Maybe<AnalysisType>;
};

export type SetAnalysisNotificationsMutation = {
  __typename?: 'SetAnalysisNotificationsMutation';
  analysis?: Maybe<AnalysisType>;
};

export type SetBudgetInitialPropertyTypeMutation = {
  __typename?: 'SetBudgetInitialPropertyTypeMutation';
  propertyDetails?: Maybe<BudgetPropertyDetailsType>;
};

export type SetBudgetPropertyTypeInput = {
  propertyType: Scalars['String']['input'];
  rehabBudgetId: Scalars['ID']['input'];
};

export type SetLoanProductMutation = {
  __typename?: 'SetLoanProductMutation';
  userProfile?: Maybe<UserType>;
};

export type ShortUrlType = {
  __typename?: 'ShortUrlType';
  originalUrl: Scalars['String']['output'];
  shortCode: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** SourcedPropertyType */
export type SourcedPropertyType = {
  __typename?: 'SourcedPropertyType';
  emailUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  property: PropertyType;
  purchasePrice?: Maybe<Scalars['Int']['output']>;
  sentAt?: Maybe<Scalars['DateTime']['output']>;
  sourceEmail?: Maybe<Scalars['String']['output']>;
  user: UserType;
};

export type SubmitRehabBudgetInput = {
  rehabBudgetId: Scalars['ID']['input'];
};

export type SubmitRehabBudgetMutation = {
  __typename?: 'SubmitRehabBudgetMutation';
  rehabBudget?: Maybe<RehabBudgetType>;
};

export type TaskType =
  | 'COMPLETE_INQUIRY'
  | 'COMPLETE_REHAB_SOW'
  | 'SOFT_CREDIT_PULL'
  | 'UPLOAD_DOCUMENTS';

export type TeamInfoType = {
  __typename?: 'TeamInfoType';
  /** Draws analyst details */
  drawsAnalyst?: Maybe<TeamMemberType>;
  /** Member representative details */
  memberRepresentative?: Maybe<TeamMemberType>;
  /** Servicing analyst details */
  servicingAnalyst?: Maybe<TeamMemberType>;
};

export type TeamMemberType = {
  __typename?: 'TeamMemberType';
  /** Team member email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Team member name */
  name?: Maybe<Scalars['String']['output']>;
  /** Team member phone number */
  phone?: Maybe<Scalars['String']['output']>;
};

/** Current completion status of the timeline item. */
export type TimelineItemStatus =
  | 'complete'
  | 'inprogress'
  | 'todo'
  | 'waiting'
  | 'waiting_urgent';

export type TimelineItemType = {
  __typename?: 'TimelineItemType';
  /** Longer description or related copy for the item / stage. */
  description: Scalars['String']['output'];
  /** Current item / stage completion status. */
  status: TimelineItemStatus;
  /** Title length description of the item / stage. */
  title: Scalars['String']['output'];
};

/** All possible application timeline stages. */
export type TimelineStage =
  | 'clear_to_close'
  | 'closing_day'
  | 'conditionally_approved'
  | 'current'
  | 'initial_processing'
  | 'pre_submit'
  | 'processing'
  | 'repaid'
  | 'submitted'
  | 'term_sheet_approved';

export type TimelineStageType = {
  __typename?: 'TimelineStageType';
  /** Display name of the timeline stage. */
  label: Scalars['String']['output'];
  /** Internal name of the timeline stage. */
  value: TimelineStage;
};

/** GraphQL type for TrustedPartner */
export type TrustedPartnerType = {
  __typename?: 'TrustedPartnerType';
  /** The category of service this partner provides. */
  category: DynamicContentTrustedPartnerCategoryChoices;
  /** Text for the call-to-action button that links to the partner website. */
  ctaText: Scalars['String']['output'];
  /** A detailed description of the partner's services. */
  description: Scalars['String']['output'];
  /** Order in which to display partners (lower numbers shown first). */
  displayOrder: Scalars['Int']['output'];
  /** Contact email for the partner. */
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** The name of the partner company or service provider. */
  name: Scalars['String']['output'];
  /** Contact phone number for the partner. */
  phone?: Maybe<Scalars['String']['output']>;
  /** URL-friendly version of the partner name. Auto-generated if left blank. */
  slug: Scalars['String']['output'];
  /** Link to the partner's website or service. */
  webLink?: Maybe<Scalars['String']['output']>;
};

export type UnArchiveApplicationMutation = {
  __typename?: 'UnArchiveApplicationMutation';
  application?: Maybe<LoanType>;
};

export type UnArchiveInput = {
  applicationId: Scalars['ID']['input'];
};

/** Mutation to delete a user device. */
export type UnregisterDeviceMutation = {
  __typename?: 'UnregisterDeviceMutation';
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation to Update a Pre-Existing Analysis with a New Set of Comps */
export type UpdateAnalysisCompsMutation = {
  __typename?: 'UpdateAnalysisCompsMutation';
  analysis?: Maybe<AnalysisType>;
};

/** Update an existing analysis */
export type UpdateAnalysisMutation = {
  __typename?: 'UpdateAnalysisMutation';
  analysis?: Maybe<AnalysisType>;
};

export type UpdateBudgetLineItemMutation = {
  __typename?: 'UpdateBudgetLineItemMutation';
  budgetLineItem?: Maybe<BudgetLineItemType>;
};

export type UpdateBudgetPropertyDetailsInput = {
  propertyBaths?: InputMaybe<Scalars['Decimal']['input']>;
  propertyBeds?: InputMaybe<Scalars['Int']['input']>;
  propertySqFt?: InputMaybe<Scalars['Int']['input']>;
  propertyType?: InputMaybe<Scalars['String']['input']>;
  rehabBudgetId: Scalars['ID']['input'];
};

export type UpdateBudgetPropertyDetailsMutation = {
  __typename?: 'UpdateBudgetPropertyDetailsMutation';
  propertyDetails?: Maybe<BudgetPropertyDetailsType>;
};

/** Update an existing loan application */
export type UpdateLoanApplicationMutation = {
  __typename?: 'UpdateLoanApplicationMutation';
  loanApplication?: Maybe<LoanApplicationType>;
};

export type UpdatePrimaryDrawsContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  isGc?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  rehabBudgetId: Scalars['ID']['input'];
};

export type UpdatePrimaryDrawsContactMutation = {
  __typename?: 'UpdatePrimaryDrawsContactMutation';
  contactDetails?: Maybe<BudgetContactDetailsType>;
};

export type UpdateRehabBudgetInput = {
  contingencyAmount?: InputMaybe<Scalars['Decimal']['input']>;
  projectDescription?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRehabBudgetMutation = {
  __typename?: 'UpdateRehabBudgetMutation';
  rehabBudget?: Maybe<RehabBudgetType>;
};

/** Retrieve Market Data for a User by Latitude and Longitude, Zip or City and State */
export type UpdateUserMarketData = {
  __typename?: 'UpdateUserMarketData';
  marketData?: Maybe<MarketDataType>;
};

export type UpsertBudgetLineItemInput = {
  budget?: InputMaybe<Scalars['Decimal']['input']>;
  category: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  rehabBudgetId: Scalars['ID']['input'];
  selection?: InputMaybe<Scalars['StringOrList']['input']>;
};

/** GraphQL type for UserDevice model. */
export type UserDeviceType = {
  __typename?: 'UserDeviceType';
  createdAt: Scalars['DateTime']['output'];
  deviceType: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  notificationToken: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserProfileInput = {
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flips?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileMutation = {
  __typename?: 'UserProfileMutation';
  result?: Maybe<UserProfileUpdateResult>;
};

export type UserProfileUpdateError = {
  __typename?: 'UserProfileUpdateError';
  errorField: Scalars['String']['output'];
  errorText: Scalars['String']['output'];
};

export type UserProfileUpdateResult = UserProfileUpdateError | UserProfileUpdateSuccess;

export type UserProfileUpdateSuccess = {
  __typename?: 'UserProfileUpdateSuccess';
  /** An updated auth token is returned when the email address is updated. */
  token?: Maybe<Scalars['String']['output']>;
};

/** UserType */
export type UserType = {
  __typename?: 'UserType';
  assetReport?: Maybe<Scalars['JSONString']['output']>;
  assetReportToken?: Maybe<Scalars['String']['output']>;
  attribution?: Maybe<AccountsUserAttributionChoices>;
  availableReferrals: Scalars['Int']['output'];
  backgroundCheckReport?: Maybe<Scalars['JSONString']['output']>;
  backgroundCheckReportComplete?: Maybe<Scalars['Boolean']['output']>;
  betaUser: Scalars['Boolean']['output'];
  birthdate?: Maybe<Scalars['Date']['output']>;
  buyBox?: Maybe<BuyBoxType>;
  campaign?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  creditData?: Maybe<Scalars['JSONString']['output']>;
  criminalBackground?: Maybe<Scalars['JSONString']['output']>;
  defaultLoanProduct?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  flips?: Maybe<Scalars['Int']['output']>;
  foreclosureSearch?: Maybe<Scalars['JSONString']['output']>;
  googleToken?: Maybe<GoogleTokenType>;
  hasLoanApplication?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  isActiveInvestor: Scalars['Boolean']['output'];
  isAttendee: Scalars['Boolean']['output'];
  isBackflipEmployee?: Maybe<Scalars['Boolean']['output']>;
  isChannelPartner: Scalars['Boolean']['output'];
  isGuest: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  lastPointTransaction?: Maybe<PointTransactionType>;
  lifecycle?: Maybe<Scalars['String']['output']>;
  loanApplicationCount?: Maybe<Scalars['Int']['output']>;
  loanProfile?: Maybe<LoanProfileType>;
  noticeOfDefault?: Maybe<Scalars['JSONString']['output']>;
  pendingLoanTasks?: Maybe<Scalars['Int']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  plaidAssetsId?: Maybe<Scalars['String']['output']>;
  plaidAssetsStatus?: Maybe<Scalars['Boolean']['output']>;
  plaidId?: Maybe<Scalars['String']['output']>;
  plaidIdvId?: Maybe<Scalars['String']['output']>;
  plaidIdvStatus?: Maybe<Scalars['Boolean']['output']>;
  plaidIdvStepCompleted?: Maybe<Scalars['Boolean']['output']>;
  plaidShareableUrl?: Maybe<Scalars['String']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  referralCode?: Maybe<Scalars['String']['output']>;
  rentals?: Maybe<Scalars['Int']['output']>;
  reportedCreditScore?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  timeCommitment?: Maybe<AccountsUserTimeCommitmentChoices>;
  unit?: Maybe<Scalars['String']['output']>;
  validCreditPulledAt?: Maybe<Scalars['Date']['output']>;
  verifiedExperiences?: Maybe<Scalars['Int']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
};

export type UtmInput = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type CheckAccountExistsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckAccountExistsQuery = { __typename?: 'Query', accountExists?: { __typename?: 'AccountExistsType', exists: boolean } | null };

export type AddAnalysisMutationVariables = Exact<{
  placeId: Scalars['String']['input'];
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  bathrooms?: InputMaybe<Scalars['Float']['input']>;
  area?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddAnalysisMutation = { __typename?: 'Mutation', createAnalysis?: { __typename?: 'CreateAnalysisMutation', analysis?: { __typename?: 'AnalysisType', id: string, bedrooms?: number | null, bathrooms?: number | null, area?: number | null, isFirstManualAnalysis?: boolean | null, property: { __typename?: 'PropertyType', id: string, fullAddress: string, placeId?: string | null, street: string, city?: string | null, state?: string | null, zipcode: string } } | null } | null };

export type AddLoanMutationVariables = Exact<{
  placeId?: InputMaybe<Scalars['String']['input']>;
  analysisId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddLoanMutation = { __typename?: 'Mutation', createLoanApplication?: { __typename?: 'CreateLoanApplicationMutation', loanApplication?: { __typename?: 'LoanApplicationType', id: string, borrower?: string | null, targetCloseDate?: string | null, property: { __typename?: 'PropertyType', id: string } } | null } | null };

export type AddPreApprovalRequestMutationVariables = Exact<{
  phoneNumber: Scalars['String']['input'];
  propertyId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddPreApprovalRequestMutation = { __typename?: 'Mutation', createPreApprovalRequest?: { __typename?: 'CreatePreApprovalRequestMutation', success?: boolean | null, errors?: Array<string | null> | null, preApprovalRequest?: { __typename?: 'PreApprovalRequestType', id?: string | null, phoneNumber?: string | null, property?: { __typename?: 'PropertyType', id: string } | null } | null } | null };

export type AddShareableAnalysisMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type AddShareableAnalysisMutation = { __typename?: 'Mutation', createShareableAnalysis?: { __typename?: 'CreateShareableAnalysisMutation', analysis?: { __typename?: 'AnalysisType', id: string } | null } | null };

export type AnalysesQueryVariables = Exact<{
  ordering?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  buyBoxId?: InputMaybe<Scalars['ID']['input']>;
  onlyFavorites?: InputMaybe<Scalars['Boolean']['input']>;
  onlySourced?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AnalysesQuery = { __typename?: 'Query', analyses?: Array<{ __typename?: 'AnalysisType', id: string, createdAt: string, updatedAt: string, readAt?: string | null, area?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, purchasePrice?: number | null, priceSelection?: string | null, afterRepairValue?: number | null, profit?: number | null, profitPotential?: number | null, returnOnInvestment?: number | null, roiDealScore?: string | null, isSourced: boolean, isNotificationsEligible?: boolean | null, notificationsEnabled?: boolean | null, isFavorite?: boolean | null, tags?: Array<string | null> | null, property: { __typename?: 'PropertyType', city?: string | null, state?: string | null, zipcode: string, street: string, heroImage?: string | null, fullAddress: string }, sourcedProperty?: { __typename?: 'SourcedPropertyType', sourceEmail?: string | null, sentAt?: string | null } | null, sharedFrom?: { __typename?: 'AnalysisType', id: string } | null }> | null };

export type GetCompDetailQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  arvCompId: Scalars['ID']['input'];
}>;


export type GetCompDetailQuery = { __typename?: 'Query', analysisComp?: { __typename?: 'AnalysisCompType', id: string, isSelected: boolean, arvcomp?: { __typename?: 'ARVCompType', media?: Array<string> | null, id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city: string, dateSold?: string | null, daysOnMarket?: number | null, estimatedValue?: number | null, fullAddress?: string | null, heroImage?: string | null, latitude?: number | null, longitude?: number | null, lotSize?: number | null, pricePerSqft?: number | null, pricing?: string | null, state: string, status?: string | null, street: string, updatedAt: string, yearBuilt?: number | null, zipcode: string } | null } | null };

export type AnalysisCompsQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type AnalysisCompsQuery = { __typename?: 'Query', analysis?: { __typename?: 'AnalysisType', id: string, afterRepairValue?: number | null, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, cashToClose?: number | null, createdAt: string, distance?: number | null, estimatedAnnualReturn?: number | null, estimatedRent?: number | null, financingCost: number, financingFees?: number | null, grossProfitPotential?: number | null, holdPeriod?: number | null, holdingCosts?: number | null, interestExpenseLt: number, interestExpenseSt: number, interestRate?: number | null, isBetaCohort?: boolean | null, isSourced: boolean, isNotificationsEligible?: boolean | null, notificationsEnabled?: boolean | null, notificationsEnabledAt?: string | null, isFavorite?: boolean | null, lotSize?: number | null, monthlyCashFlow?: number | null, monthlyPayment?: number | null, notes?: string | null, opex?: number | null, oneTimeCosts?: number | null, priceSelection?: string | null, loanToCostAtCompletion?: number | null, profit?: number | null, profitPotential?: number | null, rewardsCredit?: number | null, totalCostBasis?: number | null, totalLoanAmount?: number | null, isFirstManualAnalysis?: boolean | null, purchaseCost: number, purchasePrice?: number | null, readAt?: string | null, rehabCost?: number | null, rent?: number | null, returnOnInvestment?: number | null, saleCost: number, strategy: string, updatedAt: string, yearBuilt?: number | null, comps?: Array<{ __typename?: 'AnalysisCompType', id: string, isSelected: boolean, originalIndex?: number | null, compType?: string | null, arvcomp?: { __typename?: 'ARVCompType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city: string, dateSold?: string | null, daysOnMarket?: number | null, estimatedValue?: number | null, fullAddress?: string | null, heroImage?: string | null, latitude?: number | null, longitude?: number | null, lotSize?: number | null, pricePerSqft?: number | null, pricing?: string | null, state: string, status?: string | null, street: string, updatedAt: string, yearBuilt?: number | null, zipcode: string } | null } | null> | null, property: { __typename?: 'PropertyType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city?: string | null, estimatedValue?: number | null, fullAddress: string, heroImage?: string | null, latitude?: string | null, longitude?: string | null, lotSize?: number | null, media?: Array<string> | null, placeId?: string | null, state?: string | null, status?: string | null, street: string, yearBuilt?: number | null, zipcode: string }, compQueryPreference?: { __typename?: 'CompQueryPreferenceType', id: string, areaMin?: number | null, areaMax?: number | null, bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, daysSinceSold?: number | null, distance?: number | null, listingStatuses?: Array<string> | null } | null } | null };

export type AnalysisDataQueryVariables = Exact<{ [key: string]: never; }>;


export type AnalysisDataQuery = { __typename?: 'Query', analysisStats?: { __typename?: 'AnalysisStatsType', manualCount?: number | null, topAverageManualCount?: number | null, sourcedCount?: number | null, totalCount?: number | null, unreadCount?: number | null, unreadHighRoiCount?: number | null } | null };

export type AnalysisQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type AnalysisQuery = { __typename?: 'Query', analysis?: { __typename?: 'AnalysisType', id: string, afterRepairValue?: number | null, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, cashToClose?: number | null, createdAt: string, distance?: number | null, estimatedAnnualReturn?: number | null, estimatedRent?: number | null, financingCost: number, financingFees?: number | null, grossProfitPotential?: number | null, holdPeriod?: number | null, holdingCosts?: number | null, interestExpenseLt: number, interestExpenseSt: number, interestRate?: number | null, isBetaCohort?: boolean | null, isSourced: boolean, isNotificationsEligible?: boolean | null, notificationsEnabled?: boolean | null, notificationsEnabledAt?: string | null, isFavorite?: boolean | null, lotSize?: number | null, monthlyCashFlow?: number | null, monthlyPayment?: number | null, notes?: string | null, opex?: number | null, oneTimeCosts?: number | null, priceSelection?: string | null, loanToCostAtCompletion?: number | null, profit?: number | null, profitPotential?: number | null, rewardsCredit?: number | null, totalCostBasis?: number | null, totalLoanAmount?: number | null, isFirstManualAnalysis?: boolean | null, purchaseCost: number, purchasePrice?: number | null, readAt?: string | null, rehabCost?: number | null, rent?: number | null, returnOnInvestment?: number | null, saleCost: number, strategy: string, updatedAt: string, yearBuilt?: number | null, property: { __typename?: 'PropertyType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city?: string | null, estimatedValue?: number | null, fullAddress: string, heroImage?: string | null, latitude?: string | null, longitude?: string | null, lotSize?: number | null, media?: Array<string> | null, placeId?: string | null, state?: string | null, status?: string | null, street: string, yearBuilt?: number | null, zipcode: string }, compQueryPreference?: { __typename?: 'CompQueryPreferenceType', id: string, areaMin?: number | null, areaMax?: number | null, bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, daysSinceSold?: number | null, distance?: number | null, listingStatuses?: Array<string> | null } | null } | null };

export type AppleLoginAuthMutationVariables = Exact<{
  serviceType: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
}>;


export type AppleLoginAuthMutation = { __typename?: 'Mutation', appleLogin?: { __typename?: 'AppleLoginMutation', token?: string | null } | null };

export type AppleLoginRegisterMutationVariables = Exact<{
  serviceType: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmInput>;
}>;


export type AppleLoginRegisterMutation = { __typename?: 'Mutation', appleLogin?: { __typename?: 'AppleLoginMutation', token?: string | null } | null };

export type ArchiveLoanMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;


export type ArchiveLoanMutation = { __typename?: 'Mutation', deleteLoanApplication?: { __typename?: 'DeleteLoanApplicationMutation', deleted?: boolean | null } | null };

export type BuyboxMutationVariables = Exact<{
  priceMin?: InputMaybe<Scalars['Int']['input']>;
  priceMax?: InputMaybe<Scalars['Int']['input']>;
  arvMin?: InputMaybe<Scalars['Int']['input']>;
  arvMax?: InputMaybe<Scalars['Int']['input']>;
  profitMin?: InputMaybe<Scalars['Int']['input']>;
  yearBuiltMin?: InputMaybe<Scalars['Int']['input']>;
  yearBuiltMax?: InputMaybe<Scalars['Int']['input']>;
  beds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  baths?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  areaMin?: InputMaybe<Scalars['Int']['input']>;
  areaMax?: InputMaybe<Scalars['Int']['input']>;
  zipCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type BuyboxMutation = { __typename?: 'Mutation', upsertBuyBox?: { __typename?: 'BuyBoxMutation', buyBox?: { __typename?: 'BuyBoxType', id: string, priceMin?: number | null, priceMax?: number | null, arvMin?: number | null, arvMax?: number | null, profitMin?: number | null, yearBuiltMin?: number | null, yearBuiltMax?: number | null, beds?: Array<string> | null, baths?: Array<string> | null, areaMin?: number | null, areaMax?: number | null, zipCodes?: Array<string> | null } | null } | null };

export type CombinedLoanAndProductsQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CombinedLoanAndProductsQuery = { __typename?: 'Query', loanApplication?: { __typename?: 'LoanApplicationType', id: string, borrower?: string | null, borrowerNames?: Array<string> | null, cashToClose?: number | null, cashToCloseRangeMin?: number | null, cashToCloseRangeMax?: number | null, creditScore?: string | null, cashAvailable?: string | null, flipsCompleted?: number | null, rentalProperties?: number | null, loanType: string, purchasePrice: number, afterRepairValue?: number | null, status?: string | null, estimatedValue: number, targetCloseDate?: string | null, contractStatus?: string | null, rehabEstimate?: number | null, earnestMoneyDeposit?: number | null, legalName?: string | null, holdPeriod?: number | null, costBasis?: number | null, grossProfit?: number | null, rewardsCredit?: number | null, rewardsTier?: string | null, estimatedCashToClose?: number | null, estimatedCashToBorrower?: number | null, loanToCost?: number | null, totalLoanAmount?: number | null, interestRate?: number | null, isPerkQualified?: boolean | null, monthlyPayment?: number | null, financingFee?: number | null, originationRate?: number | null, existingLoanAmount?: number | null, loanToCostAtCompletion?: number | null, constructionCostsSpent?: number | null, originalPurchaseDate?: string | null, leverageDiscount?: boolean | null, loanProduct?: string | null, analysis?: { __typename?: 'AnalysisType', id: string, analysisType?: string | null, comps?: Array<{ __typename?: 'AnalysisCompType', id: string } | null> | null } | null, discounts?: Array<{ __typename?: 'LoanDiscountType', discountBps?: number | null, discountType: string, expiresAt?: string | null, feeDiscount?: number | null, modifiedFee?: number | null, modifiedRate?: number | null, originalFee?: number | null, originalRate?: number | null, promotion?: string | null, rateDiscount?: number | null, status?: string | null } | null> | null, property: { __typename?: 'PropertyType', id: string, fullAddress: string, area?: number | null, bedrooms?: number | null, bathrooms?: number | null, propertyType?: string | null, street: string, city?: string | null, state?: string | null, zipcode: string }, rehabBudget?: { __typename?: 'RehabBudgetType', id: string, projectDescription?: string | null, contingencyAmount: string, status?: string | null, totalBudget?: string | null, contingencyValue?: string | null, subtotal?: string | null, hasModifiedPropertyDetails?: boolean | null, primaryDrawsContact?: { __typename?: 'BudgetContactDetailsType', id: string, name?: string | null, phone?: string | null, email?: string | null, type: string } | null, lineItems?: Array<{ __typename?: 'BudgetLineItemType', id: string, category?: string | null, budget?: number | null, memo?: string | null, selection?: string | string[] | null } | null> | null, initialPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null, modifiedPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null } | null } | null, capitalProducts?: Array<{ __typename?: 'ProductType', allowsRural?: boolean | null, creditScore?: number | null, flips?: number | null, holdPeriod?: number | null, interestRate?: number | null, isEligible?: boolean | null, isSelectable?: boolean | null, loanToAiv?: number | null, loanToArv?: number | null, loanToCostAtClosing?: number | null, loanToCostAtCompletion?: number | null, nonLicensedStates?: Array<string | null> | null, originationFee?: number | null, product?: string | null, purchasePrice?: number | null, qualifiedExperience?: number | null, qualifiedCreditScore?: number | null, qualifiedHoldPeriod?: number | null, qualifiedLoanAmount?: number | null, qualifiedMaxLoanAmount?: number | null, qualifiedPurchasePrice?: number | null, qualifiedReturnOnInvestment?: number | null, returnOnInvestment?: number | null, state?: string | null, totalLoanAmount?: number | null, cashToClose?: number | null, cashToCloseRangeMin?: number | null, cashToCloseRangeMax?: number | null } | null> | null };

export type CommunityEventFragment = { __typename?: 'CommunityEventType', address?: string | null, eventType: DynamicContentCommunityEventEventTypeChoices, description: string, eventUrl?: string | null, id: string, image?: string | null, name: string, startTime: string, venueName?: string | null, market?: { __typename?: 'EventMarketType', city: string, name: string, slug: string, state: DynamicContentEventMarketStateChoices } | null };

export type CommunityEventsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityEventsQueryQuery = { __typename?: 'Query', communityEvents?: Array<{ __typename?: 'CommunityEventType', address?: string | null, eventType: DynamicContentCommunityEventEventTypeChoices, description: string, eventUrl?: string | null, id: string, image?: string | null, name: string, startTime: string, venueName?: string | null, market?: { __typename?: 'EventMarketType', city: string, name: string, slug: string, state: DynamicContentEventMarketStateChoices } | null } | null> | null };

export type CreateAnalysisCompMutationMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  address: Scalars['String']['input'];
}>;


export type CreateAnalysisCompMutationMutation = { __typename?: 'Mutation', createAnalysisComp?: { __typename?: 'CreateAnalysisCompMutation', success?: boolean | null, message?: string | null, statusCode?: number | null, analysis?: { __typename?: 'AnalysisType', id: string, updatedAt: string, latestManualComp?: { __typename?: 'AnalysisCompType', id: string, isSelected: boolean, originalIndex?: number | null, compType?: string | null, arvcomp?: { __typename?: 'ARVCompType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city: string, dateSold?: string | null, daysOnMarket?: number | null, estimatedValue?: number | null, fullAddress?: string | null, heroImage?: string | null, latitude?: number | null, longitude?: number | null, lotSize?: number | null, pricePerSqft?: number | null, pricing?: string | null, state: string, status?: string | null, street: string, updatedAt: string, yearBuilt?: number | null, zipcode: string } | null } | null } | null } | null };

export type DeleteUserAccountMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type DeleteUserAccountMutation = { __typename?: 'Mutation', deleteAccount?: { __typename?: 'DeleteAccountMutation', result?: { __typename?: 'DeleteAccountResult', success?: boolean | null } | null } | null };

export type DisconnectMyLeadsWithReasonMutationVariables = Exact<{
  reason: Scalars['String']['input'];
  explanation?: InputMaybe<Scalars['String']['input']>;
}>;


export type DisconnectMyLeadsWithReasonMutation = { __typename?: 'Mutation', disconnectMyLeads?: { __typename?: 'DisconnectMyLeadsMutation', result?: boolean | null } | null };

export type EditAnalysisMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  analysisInput: AnalysisInput;
}>;


export type EditAnalysisMutation = { __typename?: 'Mutation', updateAnalysis?: { __typename?: 'UpdateAnalysisMutation', analysis?: { __typename?: 'AnalysisType', id: string, afterRepairValue?: number | null, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, cashToClose?: number | null, createdAt: string, distance?: number | null, estimatedAnnualReturn?: number | null, estimatedRent?: number | null, financingCost: number, financingFees?: number | null, grossProfitPotential?: number | null, holdPeriod?: number | null, holdingCosts?: number | null, interestExpenseLt: number, interestExpenseSt: number, interestRate?: number | null, isBetaCohort?: boolean | null, isSourced: boolean, isNotificationsEligible?: boolean | null, notificationsEnabled?: boolean | null, notificationsEnabledAt?: string | null, isFavorite?: boolean | null, lotSize?: number | null, monthlyCashFlow?: number | null, monthlyPayment?: number | null, notes?: string | null, opex?: number | null, oneTimeCosts?: number | null, priceSelection?: string | null, loanToCostAtCompletion?: number | null, profit?: number | null, profitPotential?: number | null, rewardsCredit?: number | null, totalCostBasis?: number | null, totalLoanAmount?: number | null, isFirstManualAnalysis?: boolean | null, purchaseCost: number, purchasePrice?: number | null, readAt?: string | null, rehabCost?: number | null, rent?: number | null, returnOnInvestment?: number | null, saleCost: number, strategy: string, updatedAt: string, yearBuilt?: number | null, property: { __typename?: 'PropertyType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city?: string | null, estimatedValue?: number | null, fullAddress: string, heroImage?: string | null, latitude?: string | null, longitude?: string | null, lotSize?: number | null, media?: Array<string> | null, placeId?: string | null, state?: string | null, status?: string | null, street: string, yearBuilt?: number | null, zipcode: string }, compQueryPreference?: { __typename?: 'CompQueryPreferenceType', id: string, areaMin?: number | null, areaMax?: number | null, bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, daysSinceSold?: number | null, distance?: number | null, listingStatuses?: Array<string> | null } | null } | null } | null };

export type EditLoanMutationVariables = Exact<{
  loanId: Scalars['ID']['input'];
  loanInput: LoanApplicationInput;
}>;


export type EditLoanMutation = { __typename?: 'Mutation', updateLoanApplication?: { __typename?: 'UpdateLoanApplicationMutation', loanApplication?: { __typename?: 'LoanApplicationType', id: string } | null } | null };

export type FavoriteAnalysisMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  favorite: Scalars['Boolean']['input'];
}>;


export type FavoriteAnalysisMutation = { __typename?: 'Mutation', setAnalysisFavorite?: { __typename?: 'SetAnalysisFavoriteMutation', analysis?: { __typename?: 'AnalysisType', id: string, createdAt: string, updatedAt: string, readAt?: string | null, area?: number | null, bedrooms?: number | null, bathrooms?: number | null, yearBuilt?: number | null, purchasePrice?: number | null, priceSelection?: string | null, afterRepairValue?: number | null, profit?: number | null, profitPotential?: number | null, returnOnInvestment?: number | null, roiDealScore?: string | null, isSourced: boolean, isFavorite?: boolean | null, tags?: Array<string | null> | null, property: { __typename?: 'PropertyType', city?: string | null, state?: string | null, zipcode: string, street: string, heroImage?: string | null, fullAddress: string }, sourcedProperty?: { __typename?: 'SourcedPropertyType', sourceEmail?: string | null, sentAt?: string | null } | null, sharedFrom?: { __typename?: 'AnalysisType', id: string } | null } | null } | null };

export type RewardsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RewardsQueryQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', lastPointTransaction?: { __typename?: 'PointTransactionType', amount: number, balance: number, balanceDollarValue?: number | null, spent: number } | null } | null };

export type AnalysisFragmentFragment = { __typename?: 'AnalysisType', id: string, afterRepairValue?: number | null, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, cashToClose?: number | null, createdAt: string, distance?: number | null, estimatedAnnualReturn?: number | null, estimatedRent?: number | null, financingCost: number, financingFees?: number | null, grossProfitPotential?: number | null, holdPeriod?: number | null, holdingCosts?: number | null, interestExpenseLt: number, interestExpenseSt: number, interestRate?: number | null, isBetaCohort?: boolean | null, isSourced: boolean, isNotificationsEligible?: boolean | null, notificationsEnabled?: boolean | null, notificationsEnabledAt?: string | null, isFavorite?: boolean | null, lotSize?: number | null, monthlyCashFlow?: number | null, monthlyPayment?: number | null, notes?: string | null, opex?: number | null, oneTimeCosts?: number | null, priceSelection?: string | null, loanToCostAtCompletion?: number | null, profit?: number | null, profitPotential?: number | null, rewardsCredit?: number | null, totalCostBasis?: number | null, totalLoanAmount?: number | null, isFirstManualAnalysis?: boolean | null, purchaseCost: number, purchasePrice?: number | null, readAt?: string | null, rehabCost?: number | null, rent?: number | null, returnOnInvestment?: number | null, saleCost: number, strategy: string, updatedAt: string, yearBuilt?: number | null, property: { __typename?: 'PropertyType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city?: string | null, estimatedValue?: number | null, fullAddress: string, heroImage?: string | null, latitude?: string | null, longitude?: string | null, lotSize?: number | null, media?: Array<string> | null, placeId?: string | null, state?: string | null, status?: string | null, street: string, yearBuilt?: number | null, zipcode: string }, compQueryPreference?: { __typename?: 'CompQueryPreferenceType', id: string, areaMin?: number | null, areaMax?: number | null, bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, daysSinceSold?: number | null, distance?: number | null, listingStatuses?: Array<string> | null } | null };

export type CompFragmentFragment = { __typename?: 'ARVCompType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city: string, dateSold?: string | null, daysOnMarket?: number | null, estimatedValue?: number | null, fullAddress?: string | null, heroImage?: string | null, latitude?: number | null, longitude?: number | null, lotSize?: number | null, pricePerSqft?: number | null, pricing?: string | null, state: string, status?: string | null, street: string, updatedAt: string, yearBuilt?: number | null, zipcode: string };

export type CompQueryPreferenceFragmentFragment = { __typename?: 'CompQueryPreferenceType', id: string, areaMin?: number | null, areaMax?: number | null, bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, daysSinceSold?: number | null, distance?: number | null, listingStatuses?: Array<string> | null };

export type LoanProductFragmentFragment = { __typename?: 'ProductType', allowsRural?: boolean | null, creditScore?: number | null, flips?: number | null, holdPeriod?: number | null, interestRate?: number | null, isEligible?: boolean | null, isSelectable?: boolean | null, loanToAiv?: number | null, loanToArv?: number | null, loanToCostAtClosing?: number | null, loanToCostAtCompletion?: number | null, nonLicensedStates?: Array<string | null> | null, originationFee?: number | null, product?: string | null, purchasePrice?: number | null, qualifiedExperience?: number | null, qualifiedCreditScore?: number | null, qualifiedHoldPeriod?: number | null, qualifiedLoanAmount?: number | null, qualifiedMaxLoanAmount?: number | null, qualifiedPurchasePrice?: number | null, qualifiedReturnOnInvestment?: number | null, returnOnInvestment?: number | null, state?: string | null, totalLoanAmount?: number | null, cashToClose?: number | null, cashToCloseRangeMin?: number | null, cashToCloseRangeMax?: number | null };

export type LoanFragmentFragment = { __typename?: 'LoanApplicationType', id: string, borrower?: string | null, borrowerNames?: Array<string> | null, cashToClose?: number | null, cashToCloseRangeMin?: number | null, cashToCloseRangeMax?: number | null, creditScore?: string | null, cashAvailable?: string | null, flipsCompleted?: number | null, rentalProperties?: number | null, loanType: string, purchasePrice: number, afterRepairValue?: number | null, status?: string | null, estimatedValue: number, targetCloseDate?: string | null, contractStatus?: string | null, rehabEstimate?: number | null, earnestMoneyDeposit?: number | null, legalName?: string | null, holdPeriod?: number | null, costBasis?: number | null, grossProfit?: number | null, rewardsCredit?: number | null, rewardsTier?: string | null, estimatedCashToClose?: number | null, estimatedCashToBorrower?: number | null, loanToCost?: number | null, totalLoanAmount?: number | null, interestRate?: number | null, isPerkQualified?: boolean | null, monthlyPayment?: number | null, financingFee?: number | null, originationRate?: number | null, existingLoanAmount?: number | null, loanToCostAtCompletion?: number | null, constructionCostsSpent?: number | null, originalPurchaseDate?: string | null, leverageDiscount?: boolean | null, loanProduct?: string | null, analysis?: { __typename?: 'AnalysisType', id: string, analysisType?: string | null, comps?: Array<{ __typename?: 'AnalysisCompType', id: string } | null> | null } | null, discounts?: Array<{ __typename?: 'LoanDiscountType', discountBps?: number | null, discountType: string, expiresAt?: string | null, feeDiscount?: number | null, modifiedFee?: number | null, modifiedRate?: number | null, originalFee?: number | null, originalRate?: number | null, promotion?: string | null, rateDiscount?: number | null, status?: string | null } | null> | null, property: { __typename?: 'PropertyType', id: string, fullAddress: string, area?: number | null, bedrooms?: number | null, bathrooms?: number | null, propertyType?: string | null, street: string, city?: string | null, state?: string | null, zipcode: string }, rehabBudget?: { __typename?: 'RehabBudgetType', id: string, projectDescription?: string | null, contingencyAmount: string, status?: string | null, totalBudget?: string | null, contingencyValue?: string | null, subtotal?: string | null, hasModifiedPropertyDetails?: boolean | null, primaryDrawsContact?: { __typename?: 'BudgetContactDetailsType', id: string, name?: string | null, phone?: string | null, email?: string | null, type: string } | null, lineItems?: Array<{ __typename?: 'BudgetLineItemType', id: string, category?: string | null, budget?: number | null, memo?: string | null, selection?: string | string[] | null } | null> | null, initialPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null, modifiedPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null } | null };

export type MarketTrendsDetailsFragment = { __typename?: 'MarketDataType', city?: string | null, state?: string | null, zipcode?: string | null, periodBegin?: string | null, periodEnd?: string | null, lastUpdated?: string | null, medianSalePrice?: number | null, medianSalePriceMom?: number | null, medianDom?: number | null, medianDomMom?: number | null, avgSaleToList?: number | null, avgSaleToListMom?: number | null, inventory?: number | null, inventoryMom?: number | null, homesSold?: number | null, homesSoldMom?: number | null, newListings?: number | null, newListingsMom?: number | null };

export type GetCompQueryPreferenceQueryVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  default?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCompQueryPreferenceQuery = { __typename?: 'Query', compQueryPreference?: { __typename?: 'CompQueryPreferenceType', id: string, areaMin?: number | null, areaMax?: number | null, bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, daysSinceSold?: number | null, distance?: number | null } | null };

export type GetLatestMarketingWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestMarketingWidgetQuery = { __typename?: 'Query', marketingWidget?: { __typename?: 'MarketingWidgetType', id: string, icon: DynamicContentMarketingWidgetIconChoices, iconCopy: string, heading: string, subHeading?: string | null, ctaCopy?: string | null, image?: DynamicContentMarketingWidgetImageChoices | null, startDate?: string | null, endDate?: string | null, externalLink?: string | null, forceActive?: boolean | null, updatedAt: string } | null };

export type GoogleCodeVerifyMutationVariables = Exact<{
  code: Scalars['String']['input'];
  scopes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  redirectUri: Scalars['String']['input'];
}>;


export type GoogleCodeVerifyMutation = { __typename?: 'Mutation', googleVerify?: { __typename?: 'GoogleVerifyMutation', idToken?: string | null, existing?: boolean | null } | null };

export type GoogleLoginAuthMutationVariables = Exact<{
  serviceType: Scalars['String']['input'];
  idToken: Scalars['String']['input'];
  scopes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoogleLoginAuthMutation = { __typename?: 'Mutation', googleLogin?: { __typename?: 'GoogleLoginMutation', token?: string | null } | null };

export type GoogleLoginGmailMutationVariables = Exact<{
  serviceType: Scalars['String']['input'];
  code: Scalars['String']['input'];
  scopes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type GoogleLoginGmailMutation = { __typename?: 'Mutation', googleLogin?: { __typename?: 'GoogleLoginMutation', token?: string | null } | null };

export type GoogleLoginRegisterMutationVariables = Exact<{
  serviceType: Scalars['String']['input'];
  code?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  scopes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  refCode?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmInput>;
  preQual?: InputMaybe<PreQualInput>;
}>;


export type GoogleLoginRegisterMutation = { __typename?: 'Mutation', googleLogin?: { __typename?: 'GoogleLoginMutation', token?: string | null } | null };

export type LoanDashboardQueryQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;


export type LoanDashboardQueryQuery = { __typename?: 'Query', dashboard?: { __typename?: 'LoanQueries', getApplication: { __typename: 'BFLoanApplicationType', id: string, status: LoanStatus, loanProduct: LoanProduct, interestRate?: number | null, originationRate?: number | null, loanToCost?: number | null, totalLoanAmount?: number | null, targetCloseDate?: string | null, contractStatus?: string | null, uploadPortalLink?: string | null, borrower?: string | null, borrowerNames?: Array<string> | null, flipsCompleted?: number | null, rentalProperties?: number | null, cashAvailable?: string | null, creditScore?: string | null, afterRepairValue?: number | null, purchasePrice: number, costBasis?: number | null, grossProfit?: number | null, estimatedCashToBorrower?: number | null, estimatedCashToClose?: number | null, monthlyPayment?: number | null, financingFee?: number | null, analysis?: { __typename?: 'AnalysisType', id: string, isNotificationsEligible?: boolean | null, notificationsEnabled?: boolean | null, notificationsEnabledAt?: string | null } | null, timelineStage: { __typename?: 'TimelineStageType', label: string, value: TimelineStage }, timeline: Array<{ __typename?: 'TimelineItemType', title: string, description: string, status: TimelineItemStatus }>, tasks: Array<{ __typename?: 'LoanTaskType', taskType: TaskType, isVisible: boolean, shouldNotify: boolean }>, milestones: Array<{ __typename?: 'MilestoneType', dueDate?: string | null, completedDate?: string | null, percentageDone?: number | null, description?: string | null, id: string, name?: string | null, status?: string | null, tasks: Array<{ __typename?: 'MilestoneTaskType', dealOrIndividual?: string | null, name?: string | null, description?: string | null, id: string, estimatedTime?: number | null, taskType?: string | null, taskUrl?: string | null }> }>, property: { __typename?: 'PropertyType', street: string, city?: string | null, state?: string | null, zipcode: string, heroImage?: string | null }, postClose?: { __typename?: 'PostCloseType', extensionRequestLink?: string | null, payoffRequestLink?: string | null, propertyInfo?: { __typename?: 'PropertyInfoType', address?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, monthlyPayments?: Array<{ __typename?: 'MonthlyPaymentType', loanNumber?: string | null, monthlyPayment?: number | null, servicer?: string | null, servicerLink?: string | null } | null> | null, team?: { __typename?: 'TeamInfoType', memberRepresentative?: { __typename?: 'TeamMemberType', name?: string | null, phone?: string | null, email?: string | null } | null, servicingAnalyst?: { __typename?: 'TeamMemberType', name?: string | null, phone?: string | null, email?: string | null } | null, drawsAnalyst?: { __typename?: 'TeamMemberType', name?: string | null, phone?: string | null, email?: string | null } | null } | null, loanInfo?: { __typename?: 'LoanInfoType', loanAmount?: number | null, closeDate?: string | null, product?: string | null, interestRate?: string | null, originalMaturity?: string | null, extendedMaturity?: string | null } | null, drawsBudget?: { __typename?: 'DrawsBudgetType', budgetedTotal?: number | null, budgetedLeft?: number | null, completedDrawsTotal?: number | null, pendingDrawsTotal?: number | null, trustpointBudgetUrl?: string | null, trustpointNewDrawUrl?: string | null, draws?: Array<{ __typename?: 'DrawType', id?: string | null, number?: string | null, amount?: number | null, status?: string | null, fundedDate?: string | null }> | null } | null } | null } } | null };

export type LoanApplicationsCountQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type LoanApplicationsCountQueryQuery = { __typename?: 'Query', loanApplicationsCount?: number | null };

export type LoanDashboardListQueryQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  userStatus: Scalars['String']['input'];
}>;


export type LoanDashboardListQueryQuery = { __typename?: 'Query', loanQueries?: { __typename?: 'LoanQueries', getApplications: { __typename: 'BFLoanApplicationTypeConnection', pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges: Array<{ __typename: 'BFLoanApplicationTypeEdge', cursor: string, node?: { __typename: 'BFLoanApplicationType', id: string, status: LoanStatus, statusLabel: string, property: { __typename?: 'PropertyType', street: string, city?: string | null, state?: string | null, zipcode: string, heroImage?: string | null } } | null } | null> } } | null };

export type ArchiveLoanApplicationMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type ArchiveLoanApplicationMutation = { __typename?: 'Mutation', deleteLoanApplication?: { __typename: 'DeleteLoanApplicationMutation', deleted?: boolean | null, redirectLoanId?: string | null } | null };

export type UnArchiveLoanApplicationMutationVariables = Exact<{
  applicationId: Scalars['ID']['input'];
}>;


export type UnArchiveLoanApplicationMutation = { __typename?: 'Mutation', unArchiveApplication: { __typename: 'UnArchiveApplicationMutation', application?: { __typename?: 'BFLoanApplicationType', id: string } | null } };

export type LoanQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;


export type LoanQuery = { __typename?: 'Query', loanApplication?: { __typename?: 'LoanApplicationType', id: string, borrower?: string | null, borrowerNames?: Array<string> | null, cashToClose?: number | null, cashToCloseRangeMin?: number | null, cashToCloseRangeMax?: number | null, creditScore?: string | null, cashAvailable?: string | null, flipsCompleted?: number | null, rentalProperties?: number | null, loanType: string, purchasePrice: number, afterRepairValue?: number | null, status?: string | null, estimatedValue: number, targetCloseDate?: string | null, contractStatus?: string | null, rehabEstimate?: number | null, earnestMoneyDeposit?: number | null, legalName?: string | null, holdPeriod?: number | null, costBasis?: number | null, grossProfit?: number | null, rewardsCredit?: number | null, rewardsTier?: string | null, estimatedCashToClose?: number | null, estimatedCashToBorrower?: number | null, loanToCost?: number | null, totalLoanAmount?: number | null, interestRate?: number | null, isPerkQualified?: boolean | null, monthlyPayment?: number | null, financingFee?: number | null, originationRate?: number | null, existingLoanAmount?: number | null, loanToCostAtCompletion?: number | null, constructionCostsSpent?: number | null, originalPurchaseDate?: string | null, leverageDiscount?: boolean | null, loanProduct?: string | null, analysis?: { __typename?: 'AnalysisType', id: string, analysisType?: string | null, comps?: Array<{ __typename?: 'AnalysisCompType', id: string } | null> | null } | null, discounts?: Array<{ __typename?: 'LoanDiscountType', discountBps?: number | null, discountType: string, expiresAt?: string | null, feeDiscount?: number | null, modifiedFee?: number | null, modifiedRate?: number | null, originalFee?: number | null, originalRate?: number | null, promotion?: string | null, rateDiscount?: number | null, status?: string | null } | null> | null, property: { __typename?: 'PropertyType', id: string, fullAddress: string, area?: number | null, bedrooms?: number | null, bathrooms?: number | null, propertyType?: string | null, street: string, city?: string | null, state?: string | null, zipcode: string }, rehabBudget?: { __typename?: 'RehabBudgetType', id: string, projectDescription?: string | null, contingencyAmount: string, status?: string | null, totalBudget?: string | null, contingencyValue?: string | null, subtotal?: string | null, hasModifiedPropertyDetails?: boolean | null, primaryDrawsContact?: { __typename?: 'BudgetContactDetailsType', id: string, name?: string | null, phone?: string | null, email?: string | null, type: string } | null, lineItems?: Array<{ __typename?: 'BudgetLineItemType', id: string, category?: string | null, budget?: number | null, memo?: string | null, selection?: string | string[] | null } | null> | null, initialPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null, modifiedPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null } | null } | null };

export type LoansQueryVariables = Exact<{
  ordering?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type LoansQuery = { __typename?: 'Query', loanApplications?: Array<{ __typename?: 'LoanApplicationType', id: string, createdAt: string, deletedAt?: string | null, isDeleted: boolean, status?: string | null, targetCloseDate?: string | null, fileUploadPortalLink?: string | null, property: { __typename?: 'PropertyType', id: string, fullAddress: string, street: string, city?: string | null, state?: string | null, zipcode: string, heroImage?: string | null } } | null> | null };

export type MarketDataQueryVariables = Exact<{
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
}>;


export type MarketDataQuery = { __typename?: 'Query', marketDataQuery?: { __typename?: 'MarketDataType', city?: string | null, state?: string | null, zipcode?: string | null, periodBegin?: string | null, periodEnd?: string | null, lastUpdated?: string | null, medianSalePrice?: number | null, medianSalePriceMom?: number | null, medianDom?: number | null, medianDomMom?: number | null, avgSaleToList?: number | null, avgSaleToListMom?: number | null, inventory?: number | null, inventoryMom?: number | null, homesSold?: number | null, homesSoldMom?: number | null, newListings?: number | null, newListingsMom?: number | null } | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, email: string, contactEmail?: string | null, isChannelPartner: boolean, isBackflipEmployee?: boolean | null, betaUser: boolean, firstName: string, lastName: string, street?: string | null, unit?: string | null, city?: string | null, state?: string | null, zipcode?: string | null, country?: string | null, photo?: string | null, birthdate?: string | null, isVerified: boolean, phoneNumber?: string | null, defaultLoanProduct?: string | null, referralCode?: string | null, availableReferrals: number, hasLoanApplication?: boolean | null, validCreditPulledAt?: string | null, buyBox?: { __typename?: 'BuyBoxType', id: string, areaMin?: number | null, areaMax?: number | null, arvMin?: number | null, arvMax?: number | null, priceMin?: number | null, priceMax?: number | null, profitMin?: number | null, beds?: Array<string> | null, baths?: Array<string> | null, yearBuiltMin?: number | null, yearBuiltMax?: number | null, zipCodes?: Array<string> | null } | null, googleToken?: { __typename?: 'GoogleTokenType', id: string, createdAt: string, emailExtractedAt?: string | null, email?: string | null, invalidAt?: string | null } | null, lastPointTransaction?: { __typename?: 'PointTransactionType', id: string, createdAt: string, amount: number, balance: number, spent: number, balanceDollarValue?: number | null } | null, loanProfile?: { __typename?: 'LoanProfileType', id: string, cashAvailable?: string | null, creditScore?: string | null, propertiesFlipped?: string | null, rentalsOwned?: string | null, borrower?: string | null, borrowerNames?: Array<string> | null } | null } | null, currentPreQualification?: { __typename?: 'PreQualificationType', id: string, propertiesFlipped?: string | null, rentalsOwned?: string | null, cashAvailable?: string | null, creditScore?: string | null, borrower?: string | null, borrowerNames?: Array<string> | null, firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, timeline?: string | null, intentStatus?: string | null } | null, badges?: { __typename?: 'BadgesType', unreadAnalysisCount?: number | null, unreadBuyBoxCount?: number | null } | null };

export type SetNotificationOnAnalysisMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  enableNotifications: Scalars['Boolean']['input'];
}>;


export type SetNotificationOnAnalysisMutation = { __typename?: 'Mutation', setAnalysisNotifications?: { __typename?: 'SetAnalysisNotificationsMutation', analysis?: { __typename?: 'AnalysisType', id: string, afterRepairValue?: number | null, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, cashToClose?: number | null, createdAt: string, distance?: number | null, estimatedAnnualReturn?: number | null, estimatedRent?: number | null, financingCost: number, financingFees?: number | null, grossProfitPotential?: number | null, holdPeriod?: number | null, holdingCosts?: number | null, interestExpenseLt: number, interestExpenseSt: number, interestRate?: number | null, isBetaCohort?: boolean | null, isSourced: boolean, isNotificationsEligible?: boolean | null, notificationsEnabled?: boolean | null, notificationsEnabledAt?: string | null, isFavorite?: boolean | null, lotSize?: number | null, monthlyCashFlow?: number | null, monthlyPayment?: number | null, notes?: string | null, opex?: number | null, oneTimeCosts?: number | null, priceSelection?: string | null, loanToCostAtCompletion?: number | null, profit?: number | null, profitPotential?: number | null, rewardsCredit?: number | null, totalCostBasis?: number | null, totalLoanAmount?: number | null, isFirstManualAnalysis?: boolean | null, purchaseCost: number, purchasePrice?: number | null, readAt?: string | null, rehabCost?: number | null, rent?: number | null, returnOnInvestment?: number | null, saleCost: number, strategy: string, updatedAt: string, yearBuilt?: number | null, property: { __typename?: 'PropertyType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city?: string | null, estimatedValue?: number | null, fullAddress: string, heroImage?: string | null, latitude?: string | null, longitude?: string | null, lotSize?: number | null, media?: Array<string> | null, placeId?: string | null, state?: string | null, status?: string | null, street: string, yearBuilt?: number | null, zipcode: string }, compQueryPreference?: { __typename?: 'CompQueryPreferenceType', id: string, areaMin?: number | null, areaMax?: number | null, bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, daysSinceSold?: number | null, distance?: number | null, listingStatuses?: Array<string> | null } | null } | null } | null };

export type PostCloseFragmentFragment = { __typename?: 'PostCloseType', extensionRequestLink?: string | null, payoffRequestLink?: string | null, propertyInfo?: { __typename?: 'PropertyInfoType', address?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, monthlyPayments?: Array<{ __typename?: 'MonthlyPaymentType', loanNumber?: string | null, monthlyPayment?: number | null, servicer?: string | null, servicerLink?: string | null } | null> | null, team?: { __typename?: 'TeamInfoType', memberRepresentative?: { __typename?: 'TeamMemberType', name?: string | null, phone?: string | null, email?: string | null } | null, servicingAnalyst?: { __typename?: 'TeamMemberType', name?: string | null, phone?: string | null, email?: string | null } | null, drawsAnalyst?: { __typename?: 'TeamMemberType', name?: string | null, phone?: string | null, email?: string | null } | null } | null, loanInfo?: { __typename?: 'LoanInfoType', loanAmount?: number | null, closeDate?: string | null, product?: string | null, interestRate?: string | null, originalMaturity?: string | null, extendedMaturity?: string | null } | null, drawsBudget?: { __typename?: 'DrawsBudgetType', budgetedTotal?: number | null, budgetedLeft?: number | null, completedDrawsTotal?: number | null, pendingDrawsTotal?: number | null, trustpointBudgetUrl?: string | null, trustpointNewDrawUrl?: string | null, draws?: Array<{ __typename?: 'DrawType', id?: string | null, number?: string | null, amount?: number | null, status?: string | null, fundedDate?: string | null }> | null } | null };

export type PropertyAutocompleteQueryVariables = Exact<{
  address: Scalars['String']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PropertyAutocompleteQuery = { __typename?: 'Query', googlePlaces?: Array<{ __typename?: 'GooglePlaceType', address: string, placeId?: string | null, types?: Array<string | null> | null } | null> | null };

export type GetRedfinAutocompleteQueryVariables = Exact<{
  region: Scalars['String']['input'];
}>;


export type GetRedfinAutocompleteQuery = { __typename?: 'Query', redfinAutocomplete?: Array<{ __typename?: 'RedfinAutocompleteType', region?: string | null } | null> | null };

export type RegisterDeviceTokenMutationVariables = Exact<{
  deviceType: Scalars['String']['input'];
  notificationToken: Scalars['String']['input'];
}>;


export type RegisterDeviceTokenMutation = { __typename?: 'Mutation', registerDevice?: { __typename?: 'RegisterDeviceMutation', device?: { __typename?: 'UserDeviceType', id: string } | null } | null };

export type UnRegisterDeviceTokenMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnRegisterDeviceTokenMutation = { __typename?: 'Mutation', unregisterDevice?: { __typename?: 'UnregisterDeviceMutation', success?: boolean | null } | null };

export type RegistrationMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  refCode?: InputMaybe<Scalars['String']['input']>;
  utm?: InputMaybe<UtmInput>;
  preQual?: InputMaybe<PreQualInput>;
}>;


export type RegistrationMutation = { __typename?: 'Mutation', register?: { __typename?: 'RegisterMutation', token?: string | null } | null };

export type AddRehabMutationVariables = Exact<{
  rehabBudgetId: Scalars['ID']['input'];
  input: UpdateRehabBudgetInput;
}>;


export type AddRehabMutation = { __typename?: 'Mutation', updateRehabBudget?: { __typename?: 'UpdateRehabBudgetMutation', rehabBudget?: { __typename?: 'RehabBudgetType', id: string, totalBudget?: string | null } | null } | null };

export type EditRehabMutationVariables = Exact<{
  rehabBudgetId: Scalars['ID']['input'];
  rehabInput: UpdateRehabBudgetInput;
}>;


export type EditRehabMutation = { __typename?: 'Mutation', updateRehabBudget?: { __typename?: 'UpdateRehabBudgetMutation', rehabBudget?: { __typename?: 'RehabBudgetType', id: string } | null } | null };

export type RehabFragmentFragment = { __typename?: 'RehabBudgetType', id: string, projectDescription?: string | null, contingencyAmount: string, status?: string | null, totalBudget?: string | null, contingencyValue?: string | null, subtotal?: string | null, hasModifiedPropertyDetails?: boolean | null, primaryDrawsContact?: { __typename?: 'BudgetContactDetailsType', id: string, name?: string | null, phone?: string | null, email?: string | null, type: string } | null, lineItems?: Array<{ __typename?: 'BudgetLineItemType', id: string, category?: string | null, budget?: number | null, memo?: string | null, selection?: string | string[] | null } | null> | null, initialPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null, modifiedPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null };

export type RehabQueryVariables = Exact<{
  loanApplicationId: Scalars['ID']['input'];
}>;


export type RehabQuery = { __typename?: 'Query', rehabBudget?: { __typename?: 'RehabBudgetType', id: string, projectDescription?: string | null, contingencyAmount: string, status?: string | null, totalBudget?: string | null, contingencyValue?: string | null, subtotal?: string | null, hasModifiedPropertyDetails?: boolean | null, primaryDrawsContact?: { __typename?: 'BudgetContactDetailsType', id: string, name?: string | null, phone?: string | null, email?: string | null, type: string } | null, lineItems?: Array<{ __typename?: 'BudgetLineItemType', id: string, category?: string | null, budget?: number | null, memo?: string | null, selection?: string | string[] | null } | null> | null, initialPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null, modifiedPropertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertyType?: string | null, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null } | null } | null };

export type SetBudgetInitialPropertyTypeMutationMutationVariables = Exact<{
  input: SetBudgetPropertyTypeInput;
}>;


export type SetBudgetInitialPropertyTypeMutationMutation = { __typename?: 'Mutation', setRehabBudgetInitialPropertyType?: { __typename?: 'SetBudgetInitialPropertyTypeMutation', propertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, type: string, propertyType?: string | null } | null } | null };

export type SubmitRehabBudgetMutationMutationVariables = Exact<{
  input: SubmitRehabBudgetInput;
}>;


export type SubmitRehabBudgetMutationMutation = { __typename?: 'Mutation', submitRehabBudget?: { __typename?: 'SubmitRehabBudgetMutation', rehabBudget?: { __typename?: 'RehabBudgetType', id: string, status?: string | null, contingencyAmount: string, projectDescription?: string | null } | null } | null };

export type UpdatePrimaryDrawsContactMutationMutationVariables = Exact<{
  input: UpdatePrimaryDrawsContactInput;
}>;


export type UpdatePrimaryDrawsContactMutationMutation = { __typename?: 'Mutation', updatePrimaryDrawsContact?: { __typename?: 'UpdatePrimaryDrawsContactMutation', contactDetails?: { __typename?: 'BudgetContactDetailsType', id: string, name?: string | null, phone?: string | null, email?: string | null, type: string } | null } | null };

export type UpdateBudgetPropertyDetailsMutationMutationVariables = Exact<{
  input: UpdateBudgetPropertyDetailsInput;
}>;


export type UpdateBudgetPropertyDetailsMutationMutation = { __typename?: 'Mutation', updateRehabBudgetPropertyDetails?: { __typename?: 'UpdateBudgetPropertyDetailsMutation', propertyDetails?: { __typename?: 'BudgetPropertyDetailsType', id: string, propertySqFt?: number | null, propertyBeds?: number | null, propertyBaths?: string | null, propertyType?: string | null } | null } | null };

export type UpdateBudgetLineItemMutationMutationVariables = Exact<{
  input: UpsertBudgetLineItemInput;
}>;


export type UpdateBudgetLineItemMutationMutation = { __typename?: 'Mutation', updateRehabBudgetLineItem?: { __typename?: 'UpdateBudgetLineItemMutation', budgetLineItem?: { __typename?: 'BudgetLineItemType', id: string, category?: string | null, budget?: number | null, memo?: string | null, selection?: string | string[] | null } | null } | null };

export type RemoveAnalysisMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
}>;


export type RemoveAnalysisMutation = { __typename?: 'Mutation', deleteAnalysis?: { __typename?: 'DeleteAnalysisMutation', deleted?: boolean | null } | null };

export type ResetPasswordTokenDataQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResetPasswordTokenDataQuery = { __typename?: 'Query', tokenData?: { __typename?: 'UserType', email: string, firstName: string, lastName: string } | null };

export type RewardsProgramDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RewardsProgramDataQuery = { __typename?: 'Query', rewardsProgramDetails?: { __typename?: 'RewardsProgramDetailsType', pointsDollarConversion?: number | null, pointsForReferralClose?: number | null, closesToPoints?: Array<{ __typename?: 'ClosesToRewardsPointsType', nthClose?: number | null, nextCloseReward?: number | null, nthCloseLabel?: string | null } | null> | null, tiers?: Array<{ __typename?: 'RewardsProgramTierDetailsType', name?: string | null, minPointsRequired?: number | null, label?: string | null, origFeeDiscount?: number | null, interestRateDiscount?: number | null } | null> | null } | null };

export type RunMyLeadsMutationVariables = Exact<{ [key: string]: never; }>;


export type RunMyLeadsMutation = { __typename?: 'Mutation', extractEmail?: { __typename?: 'ExtractEmailMutation', status?: string | null } | null };

export type ShortLinkRedirectQueryVariables = Exact<{
  shortCode: Scalars['String']['input'];
}>;


export type ShortLinkRedirectQuery = { __typename?: 'Query', appShortLinkRedirect?: { __typename?: 'ShortUrlType', originalUrl: string, type: string } | null };

export type SoftCreditPullMutationMutationVariables = Exact<{
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loanId?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SoftCreditPullMutationMutation = { __typename?: 'Mutation', creditReportMutation?: { __typename?: 'CreditReportMutation', result?: { __typename?: 'CreatedCreditReportResult', error?: string | null, success?: boolean | null } | null } | null };

export type TrustedPartnerFragment = { __typename?: 'TrustedPartnerType', category: DynamicContentTrustedPartnerCategoryChoices, ctaText: string, description: string, displayOrder: number, email?: string | null, id: string, logoUrl?: string | null, name: string, phone?: string | null, slug: string, webLink?: string | null };

export type TrustedPartnerQueryQueryVariables = Exact<{
  loanId: Scalars['ID']['input'];
}>;


export type TrustedPartnerQueryQuery = { __typename?: 'Query', trustedPartners?: Array<{ __typename?: 'TrustedPartnerType', category: DynamicContentTrustedPartnerCategoryChoices, ctaText: string, description: string, displayOrder: number, email?: string | null, id: string, logoUrl?: string | null, name: string, phone?: string | null, slug: string, webLink?: string | null } | null> | null };

export type UpdateCompQueryPreferenceMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  analysisCompInput: AnalysisCompInput;
}>;


export type UpdateCompQueryPreferenceMutation = { __typename?: 'Mutation', updateAnalysisComps?: { __typename?: 'UpdateAnalysisCompsMutation', analysis?: { __typename?: 'AnalysisType', id: string, afterRepairValue?: number | null, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, cashToClose?: number | null, createdAt: string, distance?: number | null, estimatedAnnualReturn?: number | null, estimatedRent?: number | null, financingCost: number, financingFees?: number | null, grossProfitPotential?: number | null, holdPeriod?: number | null, holdingCosts?: number | null, interestExpenseLt: number, interestExpenseSt: number, interestRate?: number | null, isBetaCohort?: boolean | null, isSourced: boolean, isNotificationsEligible?: boolean | null, notificationsEnabled?: boolean | null, notificationsEnabledAt?: string | null, isFavorite?: boolean | null, lotSize?: number | null, monthlyCashFlow?: number | null, monthlyPayment?: number | null, notes?: string | null, opex?: number | null, oneTimeCosts?: number | null, priceSelection?: string | null, loanToCostAtCompletion?: number | null, profit?: number | null, profitPotential?: number | null, rewardsCredit?: number | null, totalCostBasis?: number | null, totalLoanAmount?: number | null, isFirstManualAnalysis?: boolean | null, purchaseCost: number, purchasePrice?: number | null, readAt?: string | null, rehabCost?: number | null, rent?: number | null, returnOnInvestment?: number | null, saleCost: number, strategy: string, updatedAt: string, yearBuilt?: number | null, property: { __typename?: 'PropertyType', id: string, area?: number | null, bathrooms?: number | null, bedrooms?: number | null, city?: string | null, estimatedValue?: number | null, fullAddress: string, heroImage?: string | null, latitude?: string | null, longitude?: string | null, lotSize?: number | null, media?: Array<string> | null, placeId?: string | null, state?: string | null, status?: string | null, street: string, yearBuilt?: number | null, zipcode: string }, compQueryPreference?: { __typename?: 'CompQueryPreferenceType', id: string, areaMin?: number | null, areaMax?: number | null, bedsMin?: number | null, bedsMax?: number | null, bathsMin?: number | null, bathsMax?: number | null, daysSinceSold?: number | null, distance?: number | null, listingStatuses?: Array<string> | null } | null } | null } | null };

export type UpdateCompSelectionsMutationVariables = Exact<{
  analysisId: Scalars['ID']['input'];
  selectedCompIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateCompSelectionsMutation = { __typename?: 'Mutation', updateAnalysis?: { __typename?: 'UpdateAnalysisMutation', analysis?: { __typename?: 'AnalysisType', id: string, comps?: Array<{ __typename?: 'AnalysisCompType', id: string, isSelected: boolean } | null> | null } | null } | null };

export type UpdateUserMarketDataMutationVariables = Exact<{
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipcode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserMarketDataMutation = { __typename?: 'Mutation', updateUserMarketData?: { __typename?: 'UpdateUserMarketData', marketData?: { __typename?: 'MarketDataType', city?: string | null, state?: string | null, zipcode?: string | null, periodBegin?: string | null, periodEnd?: string | null, lastUpdated?: string | null, medianSalePrice?: number | null, medianSalePriceMom?: number | null, medianDom?: number | null, medianDomMom?: number | null, avgSaleToList?: number | null, avgSaleToListMom?: number | null, inventory?: number | null, inventoryMom?: number | null, homesSold?: number | null, homesSoldMom?: number | null, newListings?: number | null, newListingsMom?: number | null } | null } | null };

export type UpdateUserProfileNameMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserProfileNameMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename: 'UserProfileMutation', result?: { __typename: 'UserProfileUpdateError', errorField: string, errorText: string } | { __typename: 'UserProfileUpdateSuccess', token?: string | null } | null } | null };

export type UpdateUserProfileFlipsMutationVariables = Exact<{
  flips?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserProfileFlipsMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename: 'UserProfileMutation', result?: { __typename: 'UserProfileUpdateError', errorField: string, errorText: string } | { __typename: 'UserProfileUpdateSuccess', token?: string | null } | null } | null };

export type UpdateUserProfileEmailMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserProfileEmailMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename: 'UserProfileMutation', result?: { __typename: 'UserProfileUpdateError', errorField: string, errorText: string } | { __typename: 'UserProfileUpdateSuccess', token?: string | null } | null } | null };

export type UpdateUserProfilePhoneNumberMutationVariables = Exact<{
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserProfilePhoneNumberMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename: 'UserProfileMutation', result?: { __typename: 'UserProfileUpdateError', errorField: string, errorText: string } | { __typename: 'UserProfileUpdateSuccess', token?: string | null } | null } | null };

export type UpdateUserProfileContactEmailMutationVariables = Exact<{
  contactEmail?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserProfileContactEmailMutation = { __typename?: 'Mutation', updateUserProfile?: { __typename: 'UserProfileMutation', result?: { __typename: 'UserProfileUpdateError', errorField: string, errorText: string } | { __typename: 'UserProfileUpdateSuccess', token?: string | null } | null } | null };

export type UpsertLoanProfileMutationVariables = Exact<{
  cashAvailable?: InputMaybe<Scalars['String']['input']>;
  creditScore?: InputMaybe<Scalars['String']['input']>;
  propertiesFlipped?: InputMaybe<Scalars['String']['input']>;
  rentalsOwned?: InputMaybe<Scalars['String']['input']>;
  borrower?: InputMaybe<Scalars['String']['input']>;
  borrowerNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpsertLoanProfileMutation = { __typename?: 'Mutation', upsertPreQual?: { __typename?: 'PreQualificationMutationPayload', id?: string | null } | null };

export type UpsertLoanPreQualMutationVariables = Exact<{
  input: PreQualificationMutationInput;
}>;


export type UpsertLoanPreQualMutation = { __typename?: 'Mutation', upsertPreQual?: { __typename?: 'PreQualificationMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UserChangePasswordRequestMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type UserChangePasswordRequestMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'ChangePasswordMutation', result?: boolean | null } | null };

export type UserResetPasswordRequestMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type UserResetPasswordRequestMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'ResetPasswordMutation', token?: string | null } | null };

export type UsernamePasswordLoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type UsernamePasswordLoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginMutation', token?: string | null } | null };

export const CommunityEventFragmentDoc = gql`
    fragment CommunityEvent on CommunityEventType {
  address
  eventType
  description
  eventUrl
  id
  image
  market {
    city
    name
    slug
    state
  }
  name
  startTime
  venueName
}
    `;
export const CompQueryPreferenceFragmentFragmentDoc = gql`
    fragment CompQueryPreferenceFragment on CompQueryPreferenceType {
  id
  areaMin
  areaMax
  bedsMin
  bedsMax
  bathsMin
  bathsMax
  daysSinceSold
  distance
  listingStatuses
}
    `;
export const AnalysisFragmentFragmentDoc = gql`
    fragment AnalysisFragment on AnalysisType {
  id
  afterRepairValue
  area
  bathrooms
  bedrooms
  cashToClose
  createdAt
  distance
  estimatedAnnualReturn
  estimatedRent
  financingCost
  financingFees
  grossProfitPotential
  holdPeriod
  holdingCosts
  interestExpenseLt
  interestExpenseSt
  interestRate
  isBetaCohort
  isSourced
  isNotificationsEligible
  notificationsEnabled
  notificationsEnabledAt
  isFavorite
  lotSize
  monthlyCashFlow
  monthlyPayment
  notes
  opex
  oneTimeCosts
  priceSelection
  loanToCostAtCompletion
  profit
  profitPotential
  rewardsCredit
  totalCostBasis
  totalLoanAmount
  isFirstManualAnalysis
  property {
    id
    area
    bathrooms
    bedrooms
    city
    estimatedValue
    fullAddress
    heroImage
    latitude
    longitude
    lotSize
    media
    placeId
    state
    status
    street
    yearBuilt
    zipcode
  }
  purchaseCost
  purchasePrice
  readAt
  rehabCost
  rent
  returnOnInvestment
  saleCost
  strategy
  updatedAt
  yearBuilt
  compQueryPreference {
    ...CompQueryPreferenceFragment
  }
}
    ${CompQueryPreferenceFragmentFragmentDoc}`;
export const CompFragmentFragmentDoc = gql`
    fragment CompFragment on ARVCompType {
  id
  area
  bathrooms
  bedrooms
  city
  dateSold
  daysOnMarket
  estimatedValue
  fullAddress
  heroImage
  latitude
  longitude
  lotSize
  pricePerSqft
  pricing
  state
  status
  street
  updatedAt
  yearBuilt
  zipcode
}
    `;
export const LoanProductFragmentFragmentDoc = gql`
    fragment LoanProductFragment on ProductType {
  allowsRural
  creditScore
  flips
  holdPeriod
  interestRate
  isEligible
  isSelectable
  loanToAiv
  loanToArv
  loanToCostAtClosing
  loanToCostAtCompletion
  nonLicensedStates
  originationFee
  product
  purchasePrice
  qualifiedExperience
  qualifiedCreditScore
  qualifiedHoldPeriod
  qualifiedLoanAmount
  qualifiedMaxLoanAmount
  qualifiedPurchasePrice
  qualifiedReturnOnInvestment
  returnOnInvestment
  state
  totalLoanAmount
  cashToClose
  cashToCloseRangeMin
  cashToCloseRangeMax
}
    `;
export const RehabFragmentFragmentDoc = gql`
    fragment RehabFragment on RehabBudgetType {
  id
  projectDescription
  contingencyAmount
  status
  totalBudget
  contingencyValue
  subtotal
  hasModifiedPropertyDetails
  primaryDrawsContact {
    id
    name
    phone
    email
    type
  }
  lineItems {
    id
    category
    budget
    memo
    selection
  }
  initialPropertyDetails {
    id
    propertyType
    propertySqFt
    propertyBeds
    propertyBaths
  }
  modifiedPropertyDetails {
    id
    propertyType
    propertySqFt
    propertyBeds
    propertyBaths
  }
}
    `;
export const LoanFragmentFragmentDoc = gql`
    fragment LoanFragment on LoanApplicationType {
  id
  analysis {
    id
    analysisType
    comps {
      id
    }
  }
  discounts {
    discountBps
    discountType
    expiresAt
    feeDiscount
    modifiedFee
    modifiedRate
    originalFee
    originalRate
    promotion
    rateDiscount
    status
  }
  borrower
  borrowerNames
  cashToClose
  cashToCloseRangeMin
  cashToCloseRangeMax
  creditScore
  cashAvailable
  flipsCompleted
  rentalProperties
  loanType
  purchasePrice
  afterRepairValue
  status
  estimatedValue
  targetCloseDate
  contractStatus
  rehabEstimate
  earnestMoneyDeposit
  legalName
  holdPeriod
  costBasis
  grossProfit
  rewardsCredit
  rewardsTier
  cashToClose
  cashToCloseRangeMax
  cashToCloseRangeMin
  estimatedCashToClose
  estimatedCashToBorrower
  loanToCost
  totalLoanAmount
  interestRate
  isPerkQualified
  monthlyPayment
  financingFee
  originationRate
  existingLoanAmount
  loanToCostAtCompletion
  constructionCostsSpent
  originalPurchaseDate
  leverageDiscount
  loanProduct
  property {
    id
    fullAddress
    area
    bedrooms
    bathrooms
    propertyType
    street
    city
    state
    zipcode
  }
  rehabBudget {
    ...RehabFragment
  }
}
    ${RehabFragmentFragmentDoc}`;
export const MarketTrendsDetailsFragmentDoc = gql`
    fragment MarketTrendsDetails on MarketDataType {
  city
  state
  zipcode
  periodBegin
  periodEnd
  lastUpdated
  medianSalePrice
  medianSalePriceMom
  medianDom
  medianDomMom
  avgSaleToList
  avgSaleToListMom
  inventory
  inventoryMom
  homesSold
  homesSoldMom
  newListings
  newListingsMom
}
    `;
export const PostCloseFragmentFragmentDoc = gql`
    fragment PostCloseFragment on PostCloseType {
  extensionRequestLink
  payoffRequestLink
  propertyInfo {
    address
    city
    state
    zipCode
  }
  monthlyPayments {
    loanNumber
    monthlyPayment
    servicer
    servicerLink
  }
  team {
    memberRepresentative {
      name
      phone
      email
    }
    servicingAnalyst {
      name
      phone
      email
    }
    drawsAnalyst {
      name
      phone
      email
    }
  }
  loanInfo {
    loanAmount
    closeDate
    product
    interestRate
    originalMaturity
    extendedMaturity
  }
  drawsBudget {
    budgetedTotal
    budgetedLeft
    completedDrawsTotal
    pendingDrawsTotal
    trustpointBudgetUrl
    trustpointNewDrawUrl
    draws {
      id
      number
      amount
      status
      fundedDate
    }
  }
}
    `;
export const TrustedPartnerFragmentDoc = gql`
    fragment TrustedPartner on TrustedPartnerType {
  category
  ctaText
  description
  displayOrder
  email
  id
  logoUrl
  name
  phone
  slug
  webLink
}
    `;
export const CheckAccountExistsDocument = gql`
    query checkAccountExists($email: String!) {
  accountExists(email: $email) {
    exists
  }
}
    `;
export const AddAnalysisDocument = gql`
    mutation AddAnalysis($placeId: String!, $bedrooms: Int, $bathrooms: Float, $area: Int) {
  createAnalysis(
    placeId: $placeId
    bedrooms: $bedrooms
    bathrooms: $bathrooms
    area: $area
  ) {
    analysis {
      id
      bedrooms
      bathrooms
      area
      isFirstManualAnalysis
      property {
        id
        fullAddress
        placeId
        street
        city
        state
        zipcode
      }
    }
  }
}
    `;
export const AddLoanDocument = gql`
    mutation AddLoan($placeId: String, $analysisId: ID) {
  createLoanApplication(placeId: $placeId, analysisId: $analysisId) {
    loanApplication {
      id
      borrower
      targetCloseDate
      property {
        id
      }
    }
  }
}
    `;
export const AddPreApprovalRequestDocument = gql`
    mutation AddPreApprovalRequest($phoneNumber: String!, $propertyId: String) {
  createPreApprovalRequest(phoneNumber: $phoneNumber, propertyId: $propertyId) {
    preApprovalRequest {
      id
      phoneNumber
      property {
        id
      }
    }
    success
    errors
  }
}
    `;
export const AddShareableAnalysisDocument = gql`
    mutation AddShareableAnalysis($analysisId: ID!) {
  createShareableAnalysis(analysisId: $analysisId) {
    analysis {
      id
    }
  }
}
    `;
export const AnalysesDocument = gql`
    query Analyses($ordering: String, $page: Int, $buyBoxId: ID, $onlyFavorites: Boolean, $onlySourced: Boolean) {
  analyses(
    ordering: $ordering
    page: $page
    buyBoxId: $buyBoxId
    onlyFavorites: $onlyFavorites
    onlySourced: $onlySourced
  ) {
    id
    createdAt
    updatedAt
    readAt
    area
    bedrooms
    bathrooms
    yearBuilt
    purchasePrice
    priceSelection
    afterRepairValue
    profit
    profitPotential
    returnOnInvestment
    roiDealScore
    isSourced
    isNotificationsEligible
    notificationsEnabled
    isFavorite
    tags
    property {
      city
      state
      zipcode
      street
      heroImage
      fullAddress
    }
    sourcedProperty {
      sourceEmail
      sentAt
    }
    sharedFrom {
      id
    }
  }
}
    `;
export const GetCompDetailDocument = gql`
    query GetCompDetail($analysisId: ID!, $arvCompId: ID!) {
  analysisComp(analysisId: $analysisId, arvCompId: $arvCompId) {
    id
    isSelected
    arvcomp {
      ...CompFragment
      media
    }
  }
}
    ${CompFragmentFragmentDoc}`;
export const AnalysisCompsDocument = gql`
    query AnalysisComps($analysisId: ID!) {
  analysis(analysisId: $analysisId) {
    ...AnalysisFragment
    comps {
      id
      isSelected
      originalIndex
      compType
      arvcomp {
        ...CompFragment
      }
    }
  }
}
    ${AnalysisFragmentFragmentDoc}
${CompFragmentFragmentDoc}`;
export const AnalysisDataDocument = gql`
    query AnalysisData {
  analysisStats(intervalDays: 30) {
    manualCount
    topAverageManualCount
    sourcedCount
    totalCount
    unreadCount
    unreadHighRoiCount
  }
}
    `;
export const AnalysisDocument = gql`
    query Analysis($analysisId: ID!) {
  analysis(analysisId: $analysisId) {
    ...AnalysisFragment
  }
}
    ${AnalysisFragmentFragmentDoc}`;
export const AppleLoginAuthDocument = gql`
    mutation AppleLoginAuth($serviceType: String!, $idToken: String!) {
  appleLogin(serviceType: $serviceType, idToken: $idToken) {
    token
  }
}
    `;
export const AppleLoginRegisterDocument = gql`
    mutation AppleLoginRegister($serviceType: String!, $idToken: String!, $firstName: String, $lastName: String, $phoneNumber: String, $refCode: String, $utm: UtmInput) {
  appleLogin(
    serviceType: $serviceType
    idToken: $idToken
    firstName: $firstName
    lastName: $lastName
    phoneNumber: $phoneNumber
    refCode: $refCode
    utm: $utm
  ) {
    token
  }
}
    `;
export const ArchiveLoanDocument = gql`
    mutation ArchiveLoan($loanId: ID!) {
  deleteLoanApplication(loanApplicationId: $loanId) {
    deleted
  }
}
    `;
export const BuyboxDocument = gql`
    mutation Buybox($priceMin: Int, $priceMax: Int, $arvMin: Int, $arvMax: Int, $profitMin: Int, $yearBuiltMin: Int, $yearBuiltMax: Int, $beds: [String], $baths: [String], $areaMin: Int, $areaMax: Int, $zipCodes: [String]) {
  upsertBuyBox(
    priceMin: $priceMin
    priceMax: $priceMax
    arvMin: $arvMin
    arvMax: $arvMax
    profitMin: $profitMin
    yearBuiltMin: $yearBuiltMin
    yearBuiltMax: $yearBuiltMax
    beds: $beds
    baths: $baths
    areaMin: $areaMin
    areaMax: $areaMax
    zipCodes: $zipCodes
  ) {
    buyBox {
      id
      priceMin
      priceMax
      arvMin
      arvMax
      profitMin
      yearBuiltMin
      yearBuiltMax
      beds
      baths
      areaMin
      areaMax
      zipCodes
    }
  }
}
    `;
export const CombinedLoanAndProductsDocument = gql`
    query CombinedLoanAndProducts($loanId: ID!, $version: Int) {
  loanApplication(loanId: $loanId) {
    ...LoanFragment
  }
  capitalProducts(loanId: $loanId, version: $version) {
    ...LoanProductFragment
  }
}
    ${LoanFragmentFragmentDoc}
${LoanProductFragmentFragmentDoc}`;
export const CommunityEventsQueryDocument = gql`
    query CommunityEventsQuery {
  communityEvents {
    ...CommunityEvent
  }
}
    ${CommunityEventFragmentDoc}`;
export const CreateAnalysisCompMutationDocument = gql`
    mutation CreateAnalysisCompMutation($analysisId: ID!, $address: String!) {
  createAnalysisComp(analysisId: $analysisId, address: $address) {
    success
    message
    statusCode
    analysis {
      id
      updatedAt
      latestManualComp {
        id
        isSelected
        originalIndex
        compType
        arvcomp {
          ...CompFragment
        }
      }
    }
  }
}
    ${CompFragmentFragmentDoc}`;
export const DeleteUserAccountDocument = gql`
    mutation deleteUserAccount($userId: String!) {
  deleteAccount(userId: $userId) {
    result {
      success
    }
  }
}
    `;
export const DisconnectMyLeadsWithReasonDocument = gql`
    mutation disconnectMyLeadsWithReason($reason: String!, $explanation: String) {
  disconnectMyLeads(input: {reason: $reason, explanation: $explanation}) {
    result
  }
}
    `;
export const EditAnalysisDocument = gql`
    mutation EditAnalysis($analysisId: ID!, $analysisInput: AnalysisInput!) {
  updateAnalysis(analysisId: $analysisId, analysisInput: $analysisInput) {
    analysis {
      ...AnalysisFragment
    }
  }
}
    ${AnalysisFragmentFragmentDoc}`;
export const EditLoanDocument = gql`
    mutation EditLoan($loanId: ID!, $loanInput: LoanApplicationInput!) {
  updateLoanApplication(
    loanApplicationId: $loanId
    loanApplicationInput: $loanInput
  ) {
    loanApplication {
      id
    }
  }
}
    `;
export const FavoriteAnalysisDocument = gql`
    mutation FavoriteAnalysis($analysisId: ID!, $favorite: Boolean!) {
  setAnalysisFavorite(analysisId: $analysisId, isFavorite: $favorite) {
    analysis {
      id
      createdAt
      updatedAt
      readAt
      area
      bedrooms
      bathrooms
      yearBuilt
      purchasePrice
      priceSelection
      afterRepairValue
      profit
      profitPotential
      returnOnInvestment
      roiDealScore
      isSourced
      isFavorite
      tags
      property {
        city
        state
        zipcode
        street
        heroImage
        fullAddress
      }
      sourcedProperty {
        sourceEmail
        sentAt
      }
      sharedFrom {
        id
      }
    }
  }
}
    `;
export const RewardsQueryDocument = gql`
    query RewardsQuery {
  me {
    lastPointTransaction {
      amount
      balance
      balanceDollarValue
      spent
    }
  }
}
    `;
export const GetCompQueryPreferenceDocument = gql`
    query GetCompQueryPreference($analysisId: ID!, $default: Boolean) {
  compQueryPreference(analysisId: $analysisId, default: $default) {
    id
    areaMin
    areaMax
    bedsMin
    bedsMax
    bathsMin
    bathsMax
    daysSinceSold
    distance
  }
}
    `;
export const GetLatestMarketingWidgetDocument = gql`
    query GetLatestMarketingWidget {
  marketingWidget {
    id
    icon
    iconCopy
    heading
    subHeading
    ctaCopy
    image
    startDate
    endDate
    externalLink
    forceActive
    updatedAt
  }
}
    `;
export const GoogleCodeVerifyDocument = gql`
    mutation GoogleCodeVerify($code: String!, $scopes: [String]!, $redirectUri: String!) {
  googleVerify(code: $code, scopes: $scopes, redirectUri: $redirectUri) {
    idToken
    existing
  }
}
    `;
export const GoogleLoginAuthDocument = gql`
    mutation GoogleLoginAuth($serviceType: String!, $idToken: String!, $scopes: [String]!, $redirectUri: String) {
  googleLogin(
    serviceType: $serviceType
    idToken: $idToken
    scopes: $scopes
    redirectUri: $redirectUri
  ) {
    token
  }
}
    `;
export const GoogleLoginGmailDocument = gql`
    mutation GoogleLoginGmail($serviceType: String!, $code: String!, $scopes: [String]!, $redirectUri: String) {
  googleLogin(
    serviceType: $serviceType
    code: $code
    scopes: $scopes
    redirectUri: $redirectUri
  ) {
    token
  }
}
    `;
export const GoogleLoginRegisterDocument = gql`
    mutation GoogleLoginRegister($serviceType: String!, $code: String, $idToken: String, $scopes: [String]!, $redirectUri: String, $firstName: String, $lastName: String, $phoneNumber: String, $refCode: String, $utm: UtmInput, $preQual: PreQualInput) {
  googleLogin(
    serviceType: $serviceType
    code: $code
    idToken: $idToken
    scopes: $scopes
    redirectUri: $redirectUri
    firstName: $firstName
    lastName: $lastName
    phoneNumber: $phoneNumber
    refCode: $refCode
    utm: $utm
    preQual: $preQual
  ) {
    token
  }
}
    `;
export const LoanDashboardQueryDocument = gql`
    query LoanDashboardQuery($loanId: ID!) {
  dashboard: loanQueries {
    getApplication(applicationId: $loanId) {
      __typename
      id
      ... on BFLoanApplicationType {
        id
        analysis {
          id
          isNotificationsEligible
          notificationsEnabled
          notificationsEnabledAt
        }
        status
        loanProduct
        interestRate
        originationRate
        loanToCost
        totalLoanAmount
        targetCloseDate
        contractStatus
        uploadPortalLink
        timelineStage {
          label
          value
        }
        timeline {
          title
          description
          status
        }
        tasks {
          taskType
          isVisible
          shouldNotify
        }
        milestones {
          dueDate
          completedDate
          percentageDone
          description
          id
          name
          status
          tasks {
            dealOrIndividual
            name
            description
            id
            estimatedTime
            taskType
            taskUrl
          }
        }
        property {
          street
          city
          state
          zipcode
          heroImage
        }
        borrower
        borrowerNames
        flipsCompleted
        rentalProperties
        cashAvailable
        creditScore
        afterRepairValue
        purchasePrice
        costBasis
        grossProfit
        estimatedCashToBorrower
        estimatedCashToClose
        monthlyPayment
        financingFee
        postClose {
          ...PostCloseFragment
        }
      }
    }
  }
}
    ${PostCloseFragmentFragmentDoc}`;
export const LoanApplicationsCountQueryDocument = gql`
    query LoanApplicationsCountQuery {
  loanApplicationsCount
}
    `;
export const LoanDashboardListQueryDocument = gql`
    query LoanDashboardListQuery($after: String, $first: Int!, $userStatus: String!) {
  loanQueries {
    getApplications(
      orderBy: "-created_at"
      after: $after
      first: $first
      userStatus: $userStatus
    ) {
      __typename
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
      edges {
        __typename
        node {
          __typename
          id
          property {
            street
            city
            state
            zipcode
            heroImage
          }
          status
          statusLabel
        }
        cursor
      }
    }
  }
}
    `;
export const ArchiveLoanApplicationDocument = gql`
    mutation archiveLoanApplication($applicationId: ID!) {
  deleteLoanApplication(loanApplicationId: $applicationId) {
    __typename
    deleted
    redirectLoanId
  }
}
    `;
export const UnArchiveLoanApplicationDocument = gql`
    mutation UnArchiveLoanApplication($applicationId: ID!) {
  unArchiveApplication(input: {applicationId: $applicationId}) {
    __typename
    application {
      id
    }
  }
}
    `;
export const LoanDocument = gql`
    query Loan($loanId: ID!) {
  loanApplication(loanId: $loanId) {
    ...LoanFragment
  }
}
    ${LoanFragmentFragmentDoc}`;
export const LoansDocument = gql`
    query Loans($ordering: String, $page: Int, $filter: String) {
  loanApplications(ordering: $ordering, page: $page, filter: $filter) {
    id
    createdAt
    deletedAt
    isDeleted
    status
    targetCloseDate
    fileUploadPortalLink
    property {
      id
      fullAddress
      street
      city
      state
      zipcode
      heroImage
    }
  }
}
    `;
export const MarketDataDocument = gql`
    query MarketData($latitude: Float, $longitude: Float) {
  marketDataQuery(latitude: $latitude, longitude: $longitude) {
    ...MarketTrendsDetails
  }
}
    ${MarketTrendsDetailsFragmentDoc}`;
export const MeDocument = gql`
    query Me {
  me {
    id
    email
    contactEmail
    isChannelPartner
    isBackflipEmployee
    betaUser
    firstName
    lastName
    street
    unit
    city
    state
    zipcode
    country
    photo
    birthdate
    isVerified
    isBackflipEmployee
    isChannelPartner
    phoneNumber
    defaultLoanProduct
    referralCode
    availableReferrals
    hasLoanApplication
    validCreditPulledAt
    buyBox {
      id
      areaMin
      areaMax
      arvMin
      arvMax
      priceMin
      priceMax
      profitMin
      beds
      baths
      yearBuiltMin
      yearBuiltMax
      zipCodes
    }
    googleToken {
      id
      createdAt
      emailExtractedAt
      email
      invalidAt
    }
    lastPointTransaction {
      id
      createdAt
      amount
      balance
      spent
      balanceDollarValue
    }
    loanProfile {
      id
      cashAvailable
      creditScore
      propertiesFlipped
      rentalsOwned
      borrower
      borrowerNames
    }
  }
  currentPreQualification {
    id
    propertiesFlipped
    rentalsOwned
    cashAvailable
    creditScore
    borrower
    borrowerNames
    firstName
    lastName
    phoneNumber
    timeline
    intentStatus
  }
  badges {
    unreadAnalysisCount
    unreadBuyBoxCount
  }
}
    `;
export const SetNotificationOnAnalysisDocument = gql`
    mutation SetNotificationOnAnalysis($analysisId: ID!, $enableNotifications: Boolean!) {
  setAnalysisNotifications(
    analysisId: $analysisId
    enableNotifications: $enableNotifications
  ) {
    analysis {
      ...AnalysisFragment
    }
  }
}
    ${AnalysisFragmentFragmentDoc}`;
export const PropertyAutocompleteDocument = gql`
    query PropertyAutocomplete($address: String!, $location: String, $placeId: String) {
  googlePlaces(address: $address, location: $location, placeId: $placeId) {
    address
    placeId
    types
  }
}
    `;
export const GetRedfinAutocompleteDocument = gql`
    query GetRedfinAutocomplete($region: String!) {
  redfinAutocomplete(region: $region) {
    region
  }
}
    `;
export const RegisterDeviceTokenDocument = gql`
    mutation RegisterDeviceToken($deviceType: String!, $notificationToken: String!) {
  registerDevice(deviceType: $deviceType, notificationToken: $notificationToken) {
    device {
      id
    }
  }
}
    `;
export const UnRegisterDeviceTokenDocument = gql`
    mutation UnRegisterDeviceToken($id: ID!) {
  unregisterDevice(id: $id) {
    success
  }
}
    `;
export const RegistrationDocument = gql`
    mutation Registration($firstName: String!, $lastName: String!, $email: String!, $phoneNumber: String, $password: String!, $refCode: String, $utm: UtmInput, $preQual: PreQualInput) {
  register(
    firstName: $firstName
    lastName: $lastName
    email: $email
    phoneNumber: $phoneNumber
    password: $password
    refCode: $refCode
    utm: $utm
    preQual: $preQual
  ) {
    token
  }
}
    `;
export const AddRehabDocument = gql`
    mutation AddRehab($rehabBudgetId: ID!, $input: UpdateRehabBudgetInput!) {
  updateRehabBudget(rehabBudgetId: $rehabBudgetId, rehabBudgetInput: $input) {
    rehabBudget {
      id
      totalBudget
    }
  }
}
    `;
export const EditRehabDocument = gql`
    mutation EditRehab($rehabBudgetId: ID!, $rehabInput: UpdateRehabBudgetInput!) {
  updateRehabBudget(rehabBudgetId: $rehabBudgetId, rehabBudgetInput: $rehabInput) {
    rehabBudget {
      id
    }
  }
}
    `;
export const RehabDocument = gql`
    query Rehab($loanApplicationId: ID!) {
  rehabBudget(loanApplicationId: $loanApplicationId) {
    ...RehabFragment
  }
}
    ${RehabFragmentFragmentDoc}`;
export const SetBudgetInitialPropertyTypeMutationDocument = gql`
    mutation SetBudgetInitialPropertyTypeMutation($input: SetBudgetPropertyTypeInput!) {
  setRehabBudgetInitialPropertyType(setBudgetPropertyTypeInput: $input) {
    propertyDetails {
      id
      type
      propertyType
    }
  }
}
    `;
export const SubmitRehabBudgetMutationDocument = gql`
    mutation SubmitRehabBudgetMutation($input: SubmitRehabBudgetInput!) {
  submitRehabBudget(submitRehabBudgetInput: $input) {
    rehabBudget {
      id
      status
      contingencyAmount
      projectDescription
    }
  }
}
    `;
export const UpdatePrimaryDrawsContactMutationDocument = gql`
    mutation UpdatePrimaryDrawsContactMutation($input: UpdatePrimaryDrawsContactInput!) {
  updatePrimaryDrawsContact(drawsContactInput: $input) {
    contactDetails {
      id
      name
      phone
      email
      type
    }
  }
}
    `;
export const UpdateBudgetPropertyDetailsMutationDocument = gql`
    mutation UpdateBudgetPropertyDetailsMutation($input: UpdateBudgetPropertyDetailsInput!) {
  updateRehabBudgetPropertyDetails(propertyDetailInput: $input) {
    propertyDetails {
      id
      propertySqFt
      propertyBeds
      propertyBaths
      propertyType
    }
  }
}
    `;
export const UpdateBudgetLineItemMutationDocument = gql`
    mutation UpdateBudgetLineItemMutation($input: UpsertBudgetLineItemInput!) {
  updateRehabBudgetLineItem(lineItemInput: $input) {
    budgetLineItem {
      id
      category
      budget
      memo
      selection
    }
  }
}
    `;
export const RemoveAnalysisDocument = gql`
    mutation RemoveAnalysis($analysisId: ID!) {
  deleteAnalysis(analysisId: $analysisId) {
    deleted
  }
}
    `;
export const ResetPasswordTokenDataDocument = gql`
    query ResetPasswordTokenData($token: String) {
  tokenData(token: $token) {
    email
    firstName
    lastName
  }
}
    `;
export const RewardsProgramDataDocument = gql`
    query RewardsProgramData {
  rewardsProgramDetails {
    pointsDollarConversion
    pointsForReferralClose
    closesToPoints {
      nthClose
      nextCloseReward
      nthCloseLabel
    }
    tiers {
      name
      minPointsRequired
      label
      origFeeDiscount
      interestRateDiscount
    }
  }
}
    `;
export const RunMyLeadsDocument = gql`
    mutation RunMyLeads {
  extractEmail {
    status
  }
}
    `;
export const ShortLinkRedirectDocument = gql`
    query ShortLinkRedirect($shortCode: String!) {
  appShortLinkRedirect(shortCode: $shortCode) {
    originalUrl
    type
  }
}
    `;
export const SoftCreditPullMutationDocument = gql`
    mutation SoftCreditPullMutation($dateOfBirth: String = "", $firstName: String = "", $lastName: String = "", $loanId: String = "", $phoneNumber: String = "", $placeId: String = "") {
  creditReportMutation(
    dateOfBirth: $dateOfBirth
    firstName: $firstName
    lastName: $lastName
    loanId: $loanId
    placeId: $placeId
    phoneNumber: $phoneNumber
  ) {
    result {
      error
      success
    }
  }
}
    `;
export const TrustedPartnerQueryDocument = gql`
    query TrustedPartnerQuery($loanId: ID!) {
  trustedPartners(loanApplicationId: $loanId) {
    ...TrustedPartner
  }
}
    ${TrustedPartnerFragmentDoc}`;
export const UpdateCompQueryPreferenceDocument = gql`
    mutation UpdateCompQueryPreference($analysisId: ID!, $analysisCompInput: AnalysisCompInput!) {
  updateAnalysisComps(
    analysisId: $analysisId
    analysisCompInput: $analysisCompInput
  ) {
    analysis {
      ...AnalysisFragment
    }
  }
}
    ${AnalysisFragmentFragmentDoc}`;
export const UpdateCompSelectionsDocument = gql`
    mutation UpdateCompSelections($analysisId: ID!, $selectedCompIds: [ID!]!) {
  updateAnalysis(
    analysisId: $analysisId
    analysisInput: {selectedCompIds: $selectedCompIds}
  ) {
    analysis {
      id
      comps {
        id
        isSelected
      }
    }
  }
}
    `;
export const UpdateUserMarketDataDocument = gql`
    mutation UpdateUserMarketData($city: String, $state: String, $zipcode: String) {
  updateUserMarketData(city: $city, state: $state, zipcode: $zipcode) {
    marketData {
      ...MarketTrendsDetails
    }
  }
}
    ${MarketTrendsDetailsFragmentDoc}`;
export const UpdateUserProfileNameDocument = gql`
    mutation updateUserProfileName($firstName: String, $lastName: String) {
  updateUserProfile(input: {firstName: $firstName, lastName: $lastName}) {
    __typename
    result {
      __typename
      ... on UserProfileUpdateSuccess {
        token
      }
      ... on UserProfileUpdateError {
        errorField
        errorText
      }
    }
  }
}
    `;
export const UpdateUserProfileFlipsDocument = gql`
    mutation updateUserProfileFlips($flips: String) {
  updateUserProfile(input: {flips: $flips}) {
    __typename
    result {
      __typename
      ... on UserProfileUpdateSuccess {
        token
      }
      ... on UserProfileUpdateError {
        errorField
        errorText
      }
    }
  }
}
    `;
export const UpdateUserProfileEmailDocument = gql`
    mutation updateUserProfileEmail($email: String) {
  updateUserProfile(input: {email: $email}) {
    __typename
    result {
      __typename
      ... on UserProfileUpdateSuccess {
        token
      }
      ... on UserProfileUpdateError {
        errorField
        errorText
      }
    }
  }
}
    `;
export const UpdateUserProfilePhoneNumberDocument = gql`
    mutation updateUserProfilePhoneNumber($phoneNumber: String) {
  updateUserProfile(input: {phoneNumber: $phoneNumber}) {
    __typename
    result {
      __typename
      ... on UserProfileUpdateSuccess {
        token
      }
      ... on UserProfileUpdateError {
        errorField
        errorText
      }
    }
  }
}
    `;
export const UpdateUserProfileContactEmailDocument = gql`
    mutation updateUserProfileContactEmail($contactEmail: String) {
  updateUserProfile(input: {contactEmail: $contactEmail}) {
    __typename
    result {
      __typename
      ... on UserProfileUpdateSuccess {
        token
      }
      ... on UserProfileUpdateError {
        errorField
        errorText
      }
    }
  }
}
    `;
export const UpsertLoanProfileDocument = gql`
    mutation upsertLoanProfile($cashAvailable: String = "", $creditScore: String = "", $propertiesFlipped: String = "", $rentalsOwned: String = "", $borrower: String = "", $borrowerNames: [String] = "") {
  upsertPreQual(
    input: {cashAvailable: $cashAvailable, creditScore: $creditScore, rentalsOwned: $rentalsOwned, propertiesFlipped: $propertiesFlipped, borrower: $borrower, borrowerNames: $borrowerNames}
  ) {
    id
  }
}
    `;
export const UpsertLoanPreQualDocument = gql`
    mutation UpsertLoanPreQual($input: PreQualificationMutationInput!) {
  upsertPreQual(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export const UserChangePasswordRequestDocument = gql`
    mutation UserChangePasswordRequest($token: String!, $password: String!) {
  changePassword(token: $token, password: $password) {
    result
  }
}
    `;
export const UserResetPasswordRequestDocument = gql`
    mutation UserResetPasswordRequest($email: String!) {
  resetPassword(email: $email) {
    token
  }
}
    `;
export const UsernamePasswordLoginDocument = gql`
    mutation UsernamePasswordLogin($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    token
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    checkAccountExists(variables: CheckAccountExistsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckAccountExistsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckAccountExistsQuery>(CheckAccountExistsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkAccountExists', 'query', variables);
    },
    AddAnalysis(variables: AddAnalysisMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddAnalysisMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddAnalysisMutation>(AddAnalysisDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddAnalysis', 'mutation', variables);
    },
    AddLoan(variables?: AddLoanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddLoanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddLoanMutation>(AddLoanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddLoan', 'mutation', variables);
    },
    AddPreApprovalRequest(variables: AddPreApprovalRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddPreApprovalRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddPreApprovalRequestMutation>(AddPreApprovalRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddPreApprovalRequest', 'mutation', variables);
    },
    AddShareableAnalysis(variables: AddShareableAnalysisMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddShareableAnalysisMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddShareableAnalysisMutation>(AddShareableAnalysisDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddShareableAnalysis', 'mutation', variables);
    },
    Analyses(variables?: AnalysesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnalysesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalysesQuery>(AnalysesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Analyses', 'query', variables);
    },
    GetCompDetail(variables: GetCompDetailQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCompDetailQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompDetailQuery>(GetCompDetailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCompDetail', 'query', variables);
    },
    AnalysisComps(variables: AnalysisCompsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnalysisCompsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalysisCompsQuery>(AnalysisCompsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AnalysisComps', 'query', variables);
    },
    AnalysisData(variables?: AnalysisDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnalysisDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalysisDataQuery>(AnalysisDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AnalysisData', 'query', variables);
    },
    Analysis(variables: AnalysisQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnalysisQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnalysisQuery>(AnalysisDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Analysis', 'query', variables);
    },
    AppleLoginAuth(variables: AppleLoginAuthMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppleLoginAuthMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppleLoginAuthMutation>(AppleLoginAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppleLoginAuth', 'mutation', variables);
    },
    AppleLoginRegister(variables: AppleLoginRegisterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AppleLoginRegisterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AppleLoginRegisterMutation>(AppleLoginRegisterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AppleLoginRegister', 'mutation', variables);
    },
    ArchiveLoan(variables: ArchiveLoanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveLoanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveLoanMutation>(ArchiveLoanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ArchiveLoan', 'mutation', variables);
    },
    Buybox(variables?: BuyboxMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<BuyboxMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<BuyboxMutation>(BuyboxDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Buybox', 'mutation', variables);
    },
    CombinedLoanAndProducts(variables: CombinedLoanAndProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CombinedLoanAndProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CombinedLoanAndProductsQuery>(CombinedLoanAndProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CombinedLoanAndProducts', 'query', variables);
    },
    CommunityEventsQuery(variables?: CommunityEventsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CommunityEventsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CommunityEventsQueryQuery>(CommunityEventsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CommunityEventsQuery', 'query', variables);
    },
    CreateAnalysisCompMutation(variables: CreateAnalysisCompMutationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateAnalysisCompMutationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateAnalysisCompMutationMutation>(CreateAnalysisCompMutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'CreateAnalysisCompMutation', 'mutation', variables);
    },
    deleteUserAccount(variables: DeleteUserAccountMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteUserAccountMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteUserAccountMutation>(DeleteUserAccountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteUserAccount', 'mutation', variables);
    },
    disconnectMyLeadsWithReason(variables: DisconnectMyLeadsWithReasonMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DisconnectMyLeadsWithReasonMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DisconnectMyLeadsWithReasonMutation>(DisconnectMyLeadsWithReasonDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'disconnectMyLeadsWithReason', 'mutation', variables);
    },
    EditAnalysis(variables: EditAnalysisMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditAnalysisMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditAnalysisMutation>(EditAnalysisDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EditAnalysis', 'mutation', variables);
    },
    EditLoan(variables: EditLoanMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditLoanMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditLoanMutation>(EditLoanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EditLoan', 'mutation', variables);
    },
    FavoriteAnalysis(variables: FavoriteAnalysisMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FavoriteAnalysisMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoriteAnalysisMutation>(FavoriteAnalysisDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FavoriteAnalysis', 'mutation', variables);
    },
    RewardsQuery(variables?: RewardsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RewardsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RewardsQueryQuery>(RewardsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RewardsQuery', 'query', variables);
    },
    GetCompQueryPreference(variables: GetCompQueryPreferenceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCompQueryPreferenceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompQueryPreferenceQuery>(GetCompQueryPreferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetCompQueryPreference', 'query', variables);
    },
    GetLatestMarketingWidget(variables?: GetLatestMarketingWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetLatestMarketingWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetLatestMarketingWidgetQuery>(GetLatestMarketingWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetLatestMarketingWidget', 'query', variables);
    },
    GoogleCodeVerify(variables: GoogleCodeVerifyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GoogleCodeVerifyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GoogleCodeVerifyMutation>(GoogleCodeVerifyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GoogleCodeVerify', 'mutation', variables);
    },
    GoogleLoginAuth(variables: GoogleLoginAuthMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GoogleLoginAuthMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GoogleLoginAuthMutation>(GoogleLoginAuthDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GoogleLoginAuth', 'mutation', variables);
    },
    GoogleLoginGmail(variables: GoogleLoginGmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GoogleLoginGmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GoogleLoginGmailMutation>(GoogleLoginGmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GoogleLoginGmail', 'mutation', variables);
    },
    GoogleLoginRegister(variables: GoogleLoginRegisterMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GoogleLoginRegisterMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<GoogleLoginRegisterMutation>(GoogleLoginRegisterDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GoogleLoginRegister', 'mutation', variables);
    },
    LoanDashboardQuery(variables: LoanDashboardQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoanDashboardQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoanDashboardQueryQuery>(LoanDashboardQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LoanDashboardQuery', 'query', variables);
    },
    LoanApplicationsCountQuery(variables?: LoanApplicationsCountQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoanApplicationsCountQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoanApplicationsCountQueryQuery>(LoanApplicationsCountQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LoanApplicationsCountQuery', 'query', variables);
    },
    LoanDashboardListQuery(variables: LoanDashboardListQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoanDashboardListQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoanDashboardListQueryQuery>(LoanDashboardListQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LoanDashboardListQuery', 'query', variables);
    },
    archiveLoanApplication(variables: ArchiveLoanApplicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ArchiveLoanApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ArchiveLoanApplicationMutation>(ArchiveLoanApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'archiveLoanApplication', 'mutation', variables);
    },
    UnArchiveLoanApplication(variables: UnArchiveLoanApplicationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnArchiveLoanApplicationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnArchiveLoanApplicationMutation>(UnArchiveLoanApplicationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnArchiveLoanApplication', 'mutation', variables);
    },
    Loan(variables: LoanQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoanQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoanQuery>(LoanDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Loan', 'query', variables);
    },
    Loans(variables?: LoansQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoansQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoansQuery>(LoansDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Loans', 'query', variables);
    },
    MarketData(variables?: MarketDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MarketDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MarketDataQuery>(MarketDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'MarketData', 'query', variables);
    },
    Me(variables?: MeQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MeQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MeQuery>(MeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Me', 'query', variables);
    },
    SetNotificationOnAnalysis(variables: SetNotificationOnAnalysisMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetNotificationOnAnalysisMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetNotificationOnAnalysisMutation>(SetNotificationOnAnalysisDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetNotificationOnAnalysis', 'mutation', variables);
    },
    PropertyAutocomplete(variables: PropertyAutocompleteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PropertyAutocompleteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PropertyAutocompleteQuery>(PropertyAutocompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PropertyAutocomplete', 'query', variables);
    },
    GetRedfinAutocomplete(variables: GetRedfinAutocompleteQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetRedfinAutocompleteQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetRedfinAutocompleteQuery>(GetRedfinAutocompleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'GetRedfinAutocomplete', 'query', variables);
    },
    RegisterDeviceToken(variables: RegisterDeviceTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegisterDeviceTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegisterDeviceTokenMutation>(RegisterDeviceTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RegisterDeviceToken', 'mutation', variables);
    },
    UnRegisterDeviceToken(variables: UnRegisterDeviceTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UnRegisterDeviceTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UnRegisterDeviceTokenMutation>(UnRegisterDeviceTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UnRegisterDeviceToken', 'mutation', variables);
    },
    Registration(variables: RegistrationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RegistrationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RegistrationMutation>(RegistrationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Registration', 'mutation', variables);
    },
    AddRehab(variables: AddRehabMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddRehabMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddRehabMutation>(AddRehabDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'AddRehab', 'mutation', variables);
    },
    EditRehab(variables: EditRehabMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<EditRehabMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<EditRehabMutation>(EditRehabDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'EditRehab', 'mutation', variables);
    },
    Rehab(variables: RehabQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RehabQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RehabQuery>(RehabDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Rehab', 'query', variables);
    },
    SetBudgetInitialPropertyTypeMutation(variables: SetBudgetInitialPropertyTypeMutationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SetBudgetInitialPropertyTypeMutationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SetBudgetInitialPropertyTypeMutationMutation>(SetBudgetInitialPropertyTypeMutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SetBudgetInitialPropertyTypeMutation', 'mutation', variables);
    },
    SubmitRehabBudgetMutation(variables: SubmitRehabBudgetMutationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SubmitRehabBudgetMutationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SubmitRehabBudgetMutationMutation>(SubmitRehabBudgetMutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SubmitRehabBudgetMutation', 'mutation', variables);
    },
    UpdatePrimaryDrawsContactMutation(variables: UpdatePrimaryDrawsContactMutationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdatePrimaryDrawsContactMutationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdatePrimaryDrawsContactMutationMutation>(UpdatePrimaryDrawsContactMutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdatePrimaryDrawsContactMutation', 'mutation', variables);
    },
    UpdateBudgetPropertyDetailsMutation(variables: UpdateBudgetPropertyDetailsMutationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateBudgetPropertyDetailsMutationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBudgetPropertyDetailsMutationMutation>(UpdateBudgetPropertyDetailsMutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateBudgetPropertyDetailsMutation', 'mutation', variables);
    },
    UpdateBudgetLineItemMutation(variables: UpdateBudgetLineItemMutationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateBudgetLineItemMutationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateBudgetLineItemMutationMutation>(UpdateBudgetLineItemMutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateBudgetLineItemMutation', 'mutation', variables);
    },
    RemoveAnalysis(variables: RemoveAnalysisMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RemoveAnalysisMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RemoveAnalysisMutation>(RemoveAnalysisDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RemoveAnalysis', 'mutation', variables);
    },
    ResetPasswordTokenData(variables?: ResetPasswordTokenDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ResetPasswordTokenDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ResetPasswordTokenDataQuery>(ResetPasswordTokenDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ResetPasswordTokenData', 'query', variables);
    },
    RewardsProgramData(variables?: RewardsProgramDataQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RewardsProgramDataQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RewardsProgramDataQuery>(RewardsProgramDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RewardsProgramData', 'query', variables);
    },
    RunMyLeads(variables?: RunMyLeadsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RunMyLeadsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RunMyLeadsMutation>(RunMyLeadsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RunMyLeads', 'mutation', variables);
    },
    ShortLinkRedirect(variables: ShortLinkRedirectQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ShortLinkRedirectQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ShortLinkRedirectQuery>(ShortLinkRedirectDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ShortLinkRedirect', 'query', variables);
    },
    SoftCreditPullMutation(variables?: SoftCreditPullMutationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SoftCreditPullMutationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SoftCreditPullMutationMutation>(SoftCreditPullMutationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'SoftCreditPullMutation', 'mutation', variables);
    },
    TrustedPartnerQuery(variables: TrustedPartnerQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<TrustedPartnerQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<TrustedPartnerQueryQuery>(TrustedPartnerQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'TrustedPartnerQuery', 'query', variables);
    },
    UpdateCompQueryPreference(variables: UpdateCompQueryPreferenceMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompQueryPreferenceMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompQueryPreferenceMutation>(UpdateCompQueryPreferenceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCompQueryPreference', 'mutation', variables);
    },
    UpdateCompSelections(variables: UpdateCompSelectionsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCompSelectionsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCompSelectionsMutation>(UpdateCompSelectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateCompSelections', 'mutation', variables);
    },
    UpdateUserMarketData(variables?: UpdateUserMarketDataMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserMarketDataMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserMarketDataMutation>(UpdateUserMarketDataDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpdateUserMarketData', 'mutation', variables);
    },
    updateUserProfileName(variables?: UpdateUserProfileNameMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserProfileNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserProfileNameMutation>(UpdateUserProfileNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserProfileName', 'mutation', variables);
    },
    updateUserProfileFlips(variables?: UpdateUserProfileFlipsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserProfileFlipsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserProfileFlipsMutation>(UpdateUserProfileFlipsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserProfileFlips', 'mutation', variables);
    },
    updateUserProfileEmail(variables?: UpdateUserProfileEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserProfileEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserProfileEmailMutation>(UpdateUserProfileEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserProfileEmail', 'mutation', variables);
    },
    updateUserProfilePhoneNumber(variables?: UpdateUserProfilePhoneNumberMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserProfilePhoneNumberMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserProfilePhoneNumberMutation>(UpdateUserProfilePhoneNumberDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserProfilePhoneNumber', 'mutation', variables);
    },
    updateUserProfileContactEmail(variables?: UpdateUserProfileContactEmailMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateUserProfileContactEmailMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateUserProfileContactEmailMutation>(UpdateUserProfileContactEmailDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUserProfileContactEmail', 'mutation', variables);
    },
    upsertLoanProfile(variables?: UpsertLoanProfileMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertLoanProfileMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertLoanProfileMutation>(UpsertLoanProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'upsertLoanProfile', 'mutation', variables);
    },
    UpsertLoanPreQual(variables: UpsertLoanPreQualMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpsertLoanPreQualMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpsertLoanPreQualMutation>(UpsertLoanPreQualDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UpsertLoanPreQual', 'mutation', variables);
    },
    UserChangePasswordRequest(variables: UserChangePasswordRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserChangePasswordRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserChangePasswordRequestMutation>(UserChangePasswordRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserChangePasswordRequest', 'mutation', variables);
    },
    UserResetPasswordRequest(variables: UserResetPasswordRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UserResetPasswordRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UserResetPasswordRequestMutation>(UserResetPasswordRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UserResetPasswordRequest', 'mutation', variables);
    },
    UsernamePasswordLogin(variables: UsernamePasswordLoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UsernamePasswordLoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UsernamePasswordLoginMutation>(UsernamePasswordLoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'UsernamePasswordLogin', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;
